module.exports = {
  "lang_1": "繁體",
  "lang_2": "簡體",
  "lang_3": "English",
  "lang_4": "日本語",
  "home_0": "首頁",
  "home_000": "生鮮購物網",
  "home_001": "八方雲集(美國)",
  "home_002": "加盟合作",
  "home_00": "投資人專區",
  "home_01": "慈善基金會",
  "home_02": "ESG",
  "home_1": "安心餐點",
  "home_2": "企業簡介",
  "home_3": "最新消息",
  "home_4": "聯絡我們",
  "home_5": "快速搜尋門市",
  "home_5_0": "門市搜尋",
  "home_5_1": "快速搜尋門市",
  "home_5_2": "進階搜尋",
  "home_6": "語言 / 繁體 (切換)",
  "home_7": "堅持新鮮食材當天製作、當天運送",
  "home_8": "食材的堅持",
  "home_9": "新品上市",
  "home_10": "契作農場新鮮蔬菜 (應該有很多品項)",
  "home_11": "門市快速搜尋",
  "home_12": "給消費者最方便、最快速的門市搜尋",
  "home_13": "輸入你想要搜尋的縣市、地址、門店名字",
  "home_14": "台灣的縣市 請參閱第二張表",
  "home_15": "立即搜尋",
  "home15_1": "最近門市",
  "home_16": "打造幸福企業",
  "home_17": "新鮮美味的食材 ",
  "home_18": "“契作生產、日日配送”",
  "home_19": "營造安穩事業",
  "home_20": "“只要肯努力，水餃也能變元寶”",
  "home_21": "打造庶民連鎖餐飲品牌",
  "home_22": "“銅板美食、產品多樣”",
  "home_23": "食安的堅持",
  "home_24": "從研發口味道到檢測食材、配送過程，我們都堅持透過最專業的科技，提供最新鮮、衛生、優良的產品，讓消費者吃得安心。",
  "home_25": "品質認證",
  "home_26": "食安檢測",
  "home_27": "食安政策",
  "home_28": "最新消息",
  "home_29": "詳細內容",
  "home_30": "安心餐點",
  "home_31": "鍋貼系列",
  "home_32": "水餃系列",
  "home_33": "乾麵系列",
  "home_34": "湯麵系列",
  "home_35": "抄手系列",
  "home_36": "湯品系列",
  "home_37": "飲品系列",
  "home_38": "小菜系列",
  "home_39": "生鮮系列",
  "home_40": "檢驗報告",
  "home_41": "相關連結",
  "home_42": "香港八方雲集",
  "home_43": "Facebook",
  "home_44": "八方雲集基金會",
  "home_45": "SGS安心平台",
  "home_46": "投資人專區",
  "home_47": "服務電話",
  "home_48": "公司地址",
  "home_49": "新北市淡水區中正東路二段27號18樓",
  "home_50": "卡路里/克",
  "home_51": "蛋白質",
  "home_52": "脂肪",
  "home_53": "碳水化合物",
  "home_54": "瀏覽紀錄",
  "home_55": "觀看",
  "home_56": "梁社漢排骨",
  "home_57": "芳珍蔬食",
  "home_58": "八方雲集(美國)",
    "home_59": "八方雲集安心餐點鍋貼系列",
    "home_60": "招牌鍋貼、韭菜鍋貼、韓式辣味鍋貼、玉米鍋貼、咖哩鍋貼、新疏食鍋貼",
    "home_61": "八方雲集鍋貼系列，以特選肉品與契作高麗菜精心調配內餡，搭配特製餃皮，煎至金黃酥脆、外酥內嫩，口味多樣。從經典的招牌鍋貼、清香鮮甜的韭菜鍋貼，到辛香開胃的韓式辣味與咖哩鍋貼，還有玉米鍋貼的自然甘甜，以及新蔬食(不含肉類)鍋貼的新選擇。每一顆都在火候間展現八方雲集的職人手藝，層層香氣中蘊含滿滿誠意。",
    "home_62": "八方雲集安心餐點水餃系列",
    "home_63": "招牌水餃、韭菜水餃、韓式辣味水餃、玉米水餃、咖哩水餃、鮮蝦水較、新疏食水餃，亦提供冷凍水餃方便選購",
    "home_64": "八方雲集水餃系列，特選產地契作的新鮮高麗菜，調和特選肉品，佐以韭菜、韓式辣粉、咖哩香料、玉米、鮮蝦等多種口味，提升肉質的鮮，與新推出新蔬食(不含肉類)水餃，皆以 Q 彈餃子皮細緻包覆，為您呈現層次豐富、香氣飽滿的各式水餃滋味。此外，亦推出冷凍包裝版本，在家也能輕鬆呈現現煮美味。",
    "home_65": "八方雲集安心餐點乾麵系列",
    "home_66": "古早味乾麵、招牌乾麵、麻醬乾麵、紹辣乾麵",
    "home_67": "八方雲集乾麵系列，以現煮新鮮麵條為基底，搭配不同風味的經典醬料，呈現樸實卻難忘的滋味。古早味乾麵以油蔥與醬油香氣喚醒懷舊風味；招牌乾麵融合微辣醬汁，層次豐富；麻醬乾麵以濃郁芝麻香佐豆芽與蔥花，香濃滑順；紹辣乾麵則展現微辣椒麻口感的獨門川味，麻中帶香、辣而不嗆，每一碗都展現八方雲集對風味的用心詮釋。",
    "home_68": "八方雲集安心餐點湯麵系列",
    "home_69": "梁師傅排骨麵、紹辣珍珠餛飩麵、紹辣菜肉大餛飩麵、菜肉大餛飩麵、珍珠餛飩麵、榨菜肉絲麵、酸辣湯麵、古早味湯麵",
    "home_70": "八方雲集湯麵系列，將濃郁湯頭與新鮮麵條完美結合，打造出溫暖人心的經典風味。梁師傅排骨麵以滷製入味的排骨與蔬果豚骨高湯交織出濃郁香氣；紹辣珍珠餛飩麵與紹辣菜肉大餛飩麵，以川味湯頭為基底，辣、香、濃、麻交織出豐富層次；菜肉大餛飩麵與珍珠餛飩麵則以甘甜高湯襯托餛飩的鮮香，簡單卻耐人尋味。榨菜肉絲麵結合微酸回甘的香氣，酸辣湯麵以熱氣騰騰的酸香氣味挑動味蕾，古早味湯麵則以純粹肉燥香與高湯甜味喚醒記憶中的經典滋味。",
    "home_71": "八方雲集安心餐點湯品系列",
    "home_72": "酸辣湯、玉米濃湯、蘿蔔湯、旗魚花枝丸湯、珍珠餛飩湯、菜肉大餛飩湯",  
    "home_73": "八方雲集湯品系列以溫潤湯頭與豐富食材帶來最真誠的暖心滋味。酸辣湯融合豆腐、蔬菜與肉絲，酸香交錯、開胃滿點；玉米濃湯以玉米醬細火慢熬，綿密香甜、口感滑順；蘿蔔湯以文火慢燉，帶出自然清甜；旗魚花枝丸湯將海味精華濃縮其中，鹹香鮮美；珍珠餛飩湯與菜肉大餛飩湯以滑嫩外皮與飽滿內餡結合高湯，呈現香氣與鮮味並存的經典組合。",
    "home_74": "八方雲集安心餐點湯餃系列",
    "home_75": "酸辣湯餃、玉米湯餃",
    "home_76": "八方雲集湯餃系列，結合現煮水餃與熱湯的雙重美味，讓每一口都飽含湯香與餡香。酸辣湯餃以招牌水餃搭配料多味濃的酸辣湯，酸香中帶辣、湯濃味厚，肉餡與湯汁交融出令人難忘的鮮美滋味；玉米湯餃則以金黃玉米濃湯襯托水餃的滑嫩外皮與多汁內餡，香甜濃郁、口感層次豐富。",
    "home_77": "八方雲集安心餐點抄手系列",
    "home_78": "珍珠和風抄手、珍珠紅油抄手、菜肉和風大抄手、菜肉紅油大抄手",
    "home_79": "八方雲集抄手系列以餛飩搭配和風或紅油醬汁，呈現開胃的經典風味。珍珠和風抄手以薄皮包裹細緻肉餡，淋上甘醇和風醬，口感清爽；珍珠紅油抄手以香辣紅油襯出餡香，辣中帶甘、十分開胃。菜肉和風大抄手以翠綠餛飩配上和風醬，香氣甘潤；菜肉紅油大抄手則以紅油勾勒辛香層次，微辣中帶點甘甜。",
    "home_80": "八方雲集安心餐點小菜系列",
    "home_81": "蠔油涼拌豆腐、麻醬涼拌豆腐、紅油涼拌豆腐、古早味排骨、燉蘿蔔、和風秋葵、皮蛋豆腐、燙青菜、黃金豆腐、滷蛋、黃金泡菜、薄鹽毛豆、脆筍、豬頭皮絲",
    "home_82": "八方雲集小菜精選新鮮食材，以細膩調味呈現多層次風味。蠔油、麻醬、紅油三款涼拌豆腐各具特色，從濃郁鹹香到芝麻醇厚、再到微辣開胃；皮蛋豆腐則以綿滑豆腐搭配濃郁皮蛋，清爽中帶出層次香氣。古早味排骨先醃再炸，外酥內嫩、肉香四溢。燉蘿蔔與黃金豆腐慢煨入味，餘香溫醇；和風秋葵、燙青菜則展現蔬食的自然鮮甜。黃金泡菜、脆筍、薄鹽毛豆帶來酸甜與爽脆口感，滷蛋與豬頭皮絲以經典滷香收尾，完美搭配主餐。",
    "home_83": "八方雲集安心餐點飲品系列",
    "home_84": "香濃豆漿、香濃豆漿(無加糖)、黑豆漿、真傳特調紅茶",
    "home_85": "八方雲集飲品系列，嚴選高品質食材製成。香濃豆漿以非基因改造黃豆現磨製成，口感滑順、香氣濃郁；無加糖豆漿版本保留黃豆原香，熱量更低，是輕盈健康的好選擇。黑豆漿則富含營養、香氣溫潤；真傳特調紅茶嚴選印尼與斯里蘭卡紅茶，運用特殊發酵工法，茶香多層次、甜而不膩。每一杯都與八方雲集的餐點完美契合。", 
    "home_86": "八方雲集安心餐點生鮮冷凍系列",
    "home_87": "招牌生水餃、韭菜生水餃、韓式辣味生水餃、玉米生水餃、咖哩雞肉生水餃、鮮蝦生水餃、新蔬食生水餃、珍珠生餛飩、菜肉大生餛飩等各式口味冷凍水餃",
    "home_88": "八方雲集生鮮冷凍系列，冷凍保存方便，讓您在家也能輕鬆享受八方雲集的美味。冷凍水餃系列涵蓋多款風味：招牌高麗菜肉餡香甜鮮嫩、韭菜清香誘人、韓式辣味香辣帶勁、玉米飽滿多汁、咖哩雞肉香氣濃郁、鮮蝦海味十足，新蔬食口味更為素食族群帶來素食水餃的新選擇。餛飩系列包含珍珠生餛飩與菜肉大餛飩，皮薄餡多、美味不膩口。",
    "home_89": "八方雲集安心餐點金牌牛肉產品系列",
    "home_90": "紅燒牛肉麵、清燉牛肉麵、麻辣牛肉麵、紅燒牛肉冬粉、清燉牛肉冬粉、麻辣牛肉冬粉、紅燒牛湯餃、麻辣牛湯餃、紅燒牛湯珍珠餛飩、麻辣牛湯珍珠餛飩、紅燒牛湯菜肉大餛飩、麻辣牛湯菜肉大餛飩",
    "home_91": "八方雲集金牌牛肉麵系列以嚴選牛肉與職人熬製湯頭，呈現紅燒的濃厚深韻、清燉的醇郁清透與麻辣的川味麻香。除牛肉麵外，湯餃系列融合八方雲集招牌水餃於湯中，珍珠與菜肉餛飩則以滑嫩外皮承載濃郁湯頭香，部分門市所提供的冬粉系列口感輕盈順滑與湯底完美結合。從紅燒到麻辣，每一碗都讓香氣與層次在味蕾間展開。",
  "company_1": "經營理念",
  "company_2": "食安政策",
  "company_3": "品質認證",
  "company_4": "大事紀",
  "company_5": "區域布局",
  "company_6": "公司治理",
  "company_7": "董事會",
  "company_7_0": "董事成員",
  "company_8": "企業社會責任",
  "company_9": "台灣生產據點",
  "company_10": "利他、分享、公益",
  "company_11": "八方雲集從創立至今一直秉持著「利他、分享、公益」的精神，協助肯努力的弱勢工作者開創生機，也讓這些弱勢者得以溫飽、改善生活，應證了「只要肯努力，水餃也能變元寶」的理念。同時我們也提供了消費者安全、 新鮮、美味、平價的餐點及安心飲食的用餐環境，消費者用銅板價就能享用的庶民飲食。",
  "company_12": "八方雲集以國外先進的生產設備進行全自動化生產，嚴格控管作業品質，包括製造、冷藏、低溫配送、支援系統等，全面進行標準化管理。自2010年起取得食品安全管制系統HACCP認證，近期更取得ISO22000的認證。包括原料及產品均透過自主實驗室、SGS或全國公證第三方同步檢測，為食安做三層的把關。",
  "company_13": "除了HACCP及ISO22000的認證外，八方雲集也獲得新北市政府食品業者衛生優良獎章，此外八方雲集是第一家登錄SGS安心平台的中式餐飲，同時也針對餐桌上的產品進行抽檢，消費者都可以在安心平台上看到每年3,000張的抽驗結果，讓消費者吃得安心。",
  "company_14_0": "1998年",
  "company_14": "開設第一家八方雲集門市",
  "company_15_0": "2003年",
  "company_15": "門市高達100家",
  "company_16_0": "2008年",
  "company_16": "進入香港市場，同年於香港開設5間門市",
  "company_17_0": "2014年",
  "company_17": "福州工廠建置完成，正式進軍大陸市場",
  "company_18_0": "2019年",
  "company_18": "正式發展新品牌梁社漢排骨全台開幕店數32間，集團海內外總店數來達1,171家門市",
  "company_19_0": "台灣鍋貼水餃店連鎖餐飲",
  "company_19_1": "1. 兩處中央工廠坐落於新北市淡水與高雄鳳山",
  "company_19_2": "2. 一座蔬菜截切廠坐落於西螺",
  "company_19_3": "3. 全省門店超過1000間，以加盟為主，直營店亦穩健成長中",
  "company_20_0": "香港台式餐飲連鎖",
  "company_20_1": "1. 一間中央工廠坐落於香港新界",
  "company_20_2": "2. 超過70間門市，以直營、委託經營與加盟並行的方式，強化通路的布建",
  "company_21": "八方雲集致力建置完整的公司治理架構，強化董事會職能，並保障股東權益，考量公司整體營運以及因應內外在環境變遷，於2020年設置獨立董事，進一步落實執行有效的公司治理。",
  "company_22": "八方雲集董事會由在財金、產業、管理、法律等領域具有豐富經驗的專業經理人所組成。",
  "company_23": "八方雲集為實踐企業社會責任，並促成經濟、環境及社會之進步，以達永續發展之目標。",
  "company_23_1_2": "財團法人新北市私立",
  "company_23_1_1": "八方雲集社會福利慈善事業基金會",
  "company_23_1": "詳細內容",
  "company_23_2_1": "Sustainability Report",
  "company_23_2": "永續報告書",
  "company_23_3": "下載110年永續報告書",
  "company_23_4": "下載111年永續報告書",
  "company_24": "淡水一廠",
  "company_25": "製皮製餡原料生產自動化，金屬探測器嚴格把關，香醇現磨濃醇豆漿，高標準堅守品質始終如一",
  "company_26": "淡水二廠",
  "company_27": "美味小菜、獨門醬料研製的秘密基地",
  "company_28": "西螺截切蔬菜廠",
  "company_29": "一天使用超過35頓的高麗菜採收後冰水清洗確保鮮度及脆度",
  "company_30": "高雄一廠:",
  "company_31": "餡料、豆漿、紅茶自動化生產線每天配送",
  "company_32": "高雄二廠:",
  "company_33": "壓模製皮全自動南北供貨無縫接軌新鮮每日送達",
  "company_34_0": "2020年",
  "company_34": "取得丹堤咖啡食品股份有限公司 69%股權，增加集團多元化經營",
  "company_35_0": "2021年",
  "company_35": "正式發展新品牌芳珍蔬食於",
  "company_35_1": "於臺灣證券交易所掛牌上市",
  "company_36_0": "2022年",
  "company_36": "美國「八方雲集」首家門店於 3 月 25 日於加州開幕，營運版圖跨出亞洲市場",
  "company_36_1": "啟用屯山廠",
  "company_37_0": "2023年",
  "company_37": "美國八方雲集門市達六間",
  "company_37_1": "芳珍蔬食達44間門市",
  "company_38_0": "美國南加州台式餐飲連鎖",
  "company_38_1": "一間中央工廠，坐落於南加州爾灣（Irvine）區",
  "company_38_2": "10間門市，以直營為主",
  "company_39_0": "2024年",
  "company_39": "於台北國際牛肉麵節 - 鮮食組紅燒競賽榮獲「金牌獎」",
  "company_39_1": "集團海內外總店數超過1,300間",
  "investor_01":"組織架構",
  "investor_02":"董事會",
  "investor_03":"審計委員會",
  "investor_04":"薪酬委員會",
  "investor_05":"永續發展暨風險管理委員會",
  "investor_06":"公司制度規範",
  "investor_07":"公司治理運作情形",
  "investor_08":"內部稽核組織及運作",
  "investor_09":"與獨立董事溝通情形",
  "investor_10":"誠信經營落實情形",
  "investor_11":"防範內線交易管理落實情形",
  "investor_12":"資訊安全",
  "investor_13":"智慧財產管理",
  "investor_14":"個人資料保護",

  "investor_21":"每月營收",
  "investor_22":"財務報表",
  "investor_23":"重要財務比率",

  "investor_24":"主要股東",
  "investor_25":"股東會及年報",

  "investor_26":"股利政策",
  "investor_27":"法說會",
  "investor_28":"重大訊息與公告",

  "investor_001":"董事會多元化及獨立性",
  "investor_001_1":"八方雲集女性董事的比例高於台灣上市櫃公司平均水平。未來，公司將根據多元性原則，進一步增加女性在決策過程中的參與度。",
  "investor_002":"本公司為健全董事會結構，於「公司治理實務守則」中明訂董事會成員組成應考量多元化，並就本身運作、營運形態及發展需求，擬訂適當之多元化方針，包括但不限於性別、年齡、國籍、文化及專業知識技能，而董事成員應具備之能力如下：(1)營運判斷能力、(2)會計及財務分析能力、(3)經營管理能力、(4)危機處理能力、(5)產業知識、(6)國際市場觀、(7)領導能力、(8)決策能力。",
  "investor_003":"本公司現任董事會應選9席，現由8席董事組成，董事遴選以專業、多元為基本原則，背景包含企業管理、經濟、財務、法律、資訊等領域，均具有專業背景及經營管理實務經驗。其中獨立董事4位，獨立董事比例44%，具員工身份之董事比例13%，董事間具有配偶或二親等以內之親屬關係者比例25%，女性董事38%，個別董事落實董事會成員多元化政策之情形如下：",
  "investor_004":"職稱",
  "investor_005":"姓名",
  "investor_006":"國籍",
  "investor_007":"性別",
  "investor_008":"年齡",
  "investor_009":"兼任員工",
  "investor_010":"獨立董事任期",
  "investor_011":"具備之能力",
  "investor_012":"營運判斷能力",
  "investor_013":"會計及財務分析能力",
  "investor_014":"經營管理能力",
  "investor_015":"危機處理能力",
  "investor_016":"產業知識",
  "investor_017":"國際市場觀",
  "investor_018":"領導能力",
  "investor_019":"決策能力",
  "investor_020":"董事長",
  "investor_021":"林欣怡",
  "investor_022":"中華民國",
  "investor_023":"女",
  "investor_024":"董事",
  "investor_025":"林家鈺",
  "investor_026":"男",
  "investor_027":"林明哲",
  "investor_028":"張瑞蓮",
  "investor_029":"高秀英",
  "investor_030":"獨立董事",
  "investor_031":"邱士芳",
  "investor_032":"蕭玉娟",
  "investor_032_0":"張明輝",
  "investor_033":"饒世湛",
  "investor_034":"吳昇奇",
  "investor_035":"3年以下",
  "investor_035-1":"3-6年",
  "investor_610":"副董事長",
  "investor_611":"林明哲",
  "investor_612":"副董事長",
  "investor_613":"副董事長",
  "investor_614":"副董事長",
  "investor_615":"所具備之永續專業知識與能力",
  "investor_616":"智慧財產管理計畫",
  "investor_617":"本公司已於114年擬定智慧財產管理計畫，並將計畫內容及其執行情形提報114年11月11日董事會報告",
  "investor_618":"114年度執行情形",
  "investor_619":"1.取得智財清單與成果(統計至114年12月) :",
  "investor_620":"(1)商標：台灣有效商標數共58件(另丹堤名下計22件)，海外各區商標合計161件(另丹堤名下計15件)。",
  "investor_620_1": "" ,//留空
  "investor_621":"(2)專利：台灣專利件數2件。",
  "investor_622":"2.商標爭議處理:爭議案件共3件，已委請法律事務所處理或執行相關之必要程序。",
  "investor_623":"此外，本公司114年已派員1名參與台灣智慧財產管理規範(TIPS)自評員課程，預計115年取得台灣智慧財產管理系統(TIPS)認證。",
  "investor_624":"資訊安全事件",
  "investor_625":"114年無發生任何重大資訊安全事件所產生之相關損失。",
    "investor_626":"個人資料保護政策",
    "investor_627":"本公司遵循法令規章，重視、並組建個人資料安全維護制度；界定合理適用範疇、作業方式，以及防避他人盜取、竄改、毀損滅失或洩漏。",
    "investor_628":"負責部門及人員",
    "investor_629":"本公司「個人資料檔案安全維護計畫」，明確定義個人資料保護管理作業在行動時，組織內各角色應負擔之權責。",
    "investor_630":"1.負責人：由總經理兼任，提供個人資料保護管理作業所需資源，並且定期召開審查會議。",
    "investor_631":"2.專責人員：由法務主管兼任，負責個人資料檔案安全維護計畫之規劃、推動及執行、通報及應變等相關事宜，定期(每年至少一次)就執行任務向負責人提出書面報告。",
    "investor_632":"3.查核人員：由資安主管兼任或由負責人專案指派，負責查核個人資料檔案安全維護計畫執行情形及成效，定期將查核結果向公司代表人或經其授權之人員提出書面報告。",
    "investor_633":"4.所屬人員：各部門執行業務過程中接觸到個人資料之人員，負擔其業務範圍內個人資料的保管及保密義務。專責人員與查核人員不得為同一人員擔任。",
    "investor_634":"適用範圍",
    "investor_635":"本公司依法於特定目的下，進行個人資料的蒐集、處理及利用，提供良好服務與執行職務、業務上的必要作業；",
    "investor_636":"特定目的係指經由「個人資料保護法之特定目的及個人資料之類別」及在「個人資料保護法施行細則」第 11 條所描述之法定義務範圍內，確立本公司取得之個人資料類別，對象包含客戶和本公司員工。",
    "investor_637":"實施情形",
    "investor_638":"本公司逐年於公司內部，辦理個人資料保護相關法令規章之教育宣導，或指派所屬員工參加其他機構辦理之相關個人資料保護教育訓練或講習。",
    "investor_639":"114年10月已完成當年度個人資料保護訓練講習，課程時數25分鐘/人，參與人數共計144人，總時數60小時。",
    "investor_640":"智慧財產管理政策",
    "investor_641":"為落實公司永續經營與風險管理機制，本公司建立智慧財產管理制度，並依循營運策略持續精進，具體政策如下： ",
    "investor_642":"1.強化智財管理體系，落實智財權之管理 全面盤點國內、外商標使用狀態。",
    "investor_643":"2.強化員工對於智財權的認知 定期舉辦教育訓練，提升員工對於商標使用、智財權重要性認知。 ",
    "investor_644":"3.規範創作與設計流程，確保商標識別性與可受保護性 增修訂研發管理辦法，將預檢納入設計標準作業.",

  "investor_02001":"具體管理目標與達成情形如下：",
  "investor_02002":"管理目標",
  "investor_02003":"達成情形",
  "investor_02004":"兼任經理人之董事不宜逾董事席次三分之一",
  "investor_02005":"獨立董事席次達董事席次三分之一以上",
  "investor_02006":"適足多元之專業知識與技能",
  "investor_02007":"至少包含一位女性董事",
  "investor_02008":"二分之一以上獨立董事其連續任期不超過三屆",
  "investor_02009":"已達成",
  "investor_036":"1、本公司於109年6月24日股東會設立審計委員會取代監察人。根據中華民國法律定審計委員會成員應由全體獨立董事組成。四名獨立董事皆符合法令規定之專業、工作經驗、獨立性及兼任獨立董事家數等資格條件(請參見董事會成員介紹)。",
  "investor_037":"2、審計委員會之運作，以下列事項之監督為主要目的：",
  "investor_038":"財務報表",
  "investor_039":"稽核及會計政策與程序",
  "investor_040":"內部控制制度暨相關之政策與程序",
  "investor_041":"重大之資產或衍生性商品交易",
  "investor_042":"重大資金貸與背書或保證",
  "investor_043":"募集或發行有價證券",
  "investor_044":"衍生性金融商品及現金投資情形",
  "investor_045":"法規遵循",
  "investor_046":"經理人與董事是否有關係人交易及可能之利益衝突",
  "investor_047":"簽證會計師資歷、獨立性及績效評量",
  "investor_048":"簽證會計師之委任、解任或報酬",
  "investor_049":"財務、會計或內部稽核主管之任免",
  "investor_050":"審計委員會職責履行情形",
  "investor_051":"審計委員會績效評量自評問卷等",
  "investor_052":"第二屆審計委員會委員任期：112年6月15日至115年6月14日。最近年度(114年度)審計委員會開會5次，委員出席情形如下:",
  "investor_053":"實際出席次數",
  "investor_054":"委託出席次數",
  "investor_055":"實際出席率",
  "investor_055_1":"應出席次數",
  "investor_056":"備註",
  "investor_057":"其他應記載事項：",
  "investor_058":"一、審計委員會之運作如有下列情形之一者，應敘明審計委員會召開日期、期別、議案內容、獨立董事反對意見、保留意見或重大建議項目內容、審計委員會決議結果以及公司對審計委員會意見之處理：",
  "investor_059":"(一)證券交易法第14條之5所列事項",
  "investor_060":"屆次",
  "investor_061":"會議日期",
  "investor_0611":"會議時間",
  "investor_0612":"說明",
  "investor_0613":"簡報下載",
  "investor_0614":"影片連結",
  "investor_062":"議案內容",
  "investor_063":"獨立董事反對意見、保留意見或重大建議項目內容",
  "investor_064":"審計委員會決議結果",
  "investor_065":"獨公司對審計委員會意見之處裡",

  "investor_066":"第一屆第五次",
  "investor_067":"第一屆第六次",
  "investor_068":"第一屆第七次",
  "investor_069":"第一屆第八次",
  "investor_070":"第一屆第九次",
  "investor_071":"第一屆第十次",
  "investor_072":"第一屆第十一次",
  "investor_073":"第一屆第十二次",
  "investor_074":"第一屆第十三次",
  "investor_075":"第一屆第十四次",
  "investor_076":"第一屆第十五次",
  "investor_077":"第一屆第十六次",
  "investor_078":"第一屆第十七次",

  "investor_079":"110.01.29",
  "investor_080":"110.04.08",
  "investor_081":"110.05.13",
  "investor_082":"110.07.20",
  "investor_083":"110.08.10",
  "investor_084":"110.09.17",
  "investor_085":"110.11.10",
  "investor_086":"111.01.24",
  "investor_087":"111.03.22",
  "investor_088":"111.05.04",
  "investor_089":"111.08.09",
  "investor_090":"111.10.07",
  "investor_091":"111.11.10",

  "investor_092":"1.本公司為擴充梁社漢排骨生產線，擬購置新廠房",
  "investor_093":"2.本公司財務報告編制能力之自行評估案",
  "investor_094":"3.擬訂定本公司「公司治理實務守則」",
  "investor_095":"4.擬訂定本公司「誠信經營守則」及「誠信經營作業程序及行為指南」",
  "investor_096":"5.擬訂定本公司「企業社會責任守則」",
  "investor_097":"6.擬訂定本公司「道德行為準則」",
  "investor_098":"7.擬訂定本公司「處理董事要求之標準作業程序」",
  "investor_099":"除第1案因管理階層另有規劃而先行撤案，於日後若有其他購置計畫時再行提案外，其他議案業經四位獨立董事均同意通過。",
  "investor_100":"1.本公司109年度決算表冊案",
  "investor_101":"2.本公司109年度盈餘分配案",
  "investor_102":"3.出具本公司之「內部控制制度聲明書」案",
  "investor_103":"4.為配合本公司股票初次上市前辦理現金增資發行新股事宜，擬請原股東全數放棄優先認購權利",
  "investor_104":"5.110年度會計師公費暨獨立性評估審核案",
  "investor_105":"6.本公司擬對子公司鈁鑫國際貿易股份有限公司資金貸與新台幣3,000萬元額度案",
  "investor_106":"7.擬修訂本公司「股東會議事規則」案",
  "investor_107":"8.擬訂本公司「董事會績效評估辦法」案",
  "investor_108":"9.擬修訂本公司「董事會議事規範」案",
  "investor_109":"10.擬修訂本公司「董事選任程序」案",
  "investor_110":"11.擬修訂本公司「薪資報酬委員會組織規程」案",
  "investor_111":"12.擬修訂本公司「獨立董事之職責範疇規則」案",
  "investor_112":"1.通過本公司110年第1季合併財務報表案",
  "investor_113":"1.擬辦理現金增資發行新股作為本公司股票上市前公開承銷股份案",
  "investor_114":"1.擬通過本公司110年第2季合併財務報表案",
  "investor_115":"2.擬通過110年上半年度盈餘分配案",
  "investor_116":"1.擬承租土地及建物案",
  "investor_117":"2.擬進行淡水三廠擴廠計畫案",
  "investor_118":"1.擬通過本公司110年第3季合併財務報表案",
  "investor_119":"2.本公司擬與統一綜合證券股份有限公司進行保本票據(Principal Guaranteed Note, PGN)交易案",
  "investor_120":"3.本公司財務長任免及代理發言人異動案",
  "investor_121":"4.擬訂定本公司111年度稽核計畫案",
  "investor_122":"5.擬對子公司丹堤咖啡食品股份有限公司資金貸與新台幣5,000萬元額度案",
  "investor_123":"1.本公司新北市淡水區屯山段淡水三廠預算追加及擴建案",
  "investor_124":"2.本公司擬對子公司八方雲集餐飲股份有限公司資金貸與新台幣一億元額度案",
  "investor_125":"3.本公司擬對子公司丹堤咖啡食品股份有限公司辦理背書保證案",
  "investor_126":"4.擬增資100%轉投資Bafang Yunji International (USA) Limited及持股60%之Bafang Yunji Foods LLC案",
  "investor_127":"5.發放經理人110年度年終獎金案",
  "investor_128":"6.本公司更換簽證會計師案",
  "investor_129":"7.擬修訂本公司「財務報表編製流程管理辦法」",
  "investor_130":"8.擬修訂本公司「公司治理實務守則」",
  "investor_131":"9.擬修訂本公司「防範內線交易管理辦法」",
  "investor_132":"10.擬修訂本公司「核決權限表」",
  "investor_133":"1.擬通過本公司110年度決算表冊案",
  "investor_134":"2.擬通過110年度盈餘分配案",
  "investor_135":"3.本公司擬興建大林廠計畫案",
  "investor_136":"4.出具本公司之「內部控制制度聲明書」案",
  "investor_137":"5.111年度會計師公費暨獨立性評估審核案",
  "investor_138":"6.擬修訂本公司「取得或處分資產處理程序」案",
  "investor_139":"7.擬修訂本公司「內部稽核實施細則」案",
  "investor_140":"8.擬修訂美國子公司之稽核計畫案",
  "investor_141":"9.擬修訂本公司「股東會議事規則」案",
  "investor_142":"1.擬通過本公司111年第1季合併財務報表案",
  "investor_143":"2.擬修訂本公司「企業社會責任實務守則」案",
  "investor_144":"3.本公司擬向子公司提前解除租約案",
  "investor_145":"1.擬通過本公司111年第2季合併財務報表案",
  "investor_146":"2.111年上半年度盈餘分配案",
  "investor_147":"3.本公司擬向子公司Bafang Yunji (Samoa) International Co., Ltd.購買八方雲集國際集團有限公司股權案",
  "investor_148":"4.子公司Bafang Yunji (Samoa) International Co., Ltd.擬辦理減資案",
  "investor_149":"5.擬註銷子公司Bafang Yunji (Samoa) Investment Company Limited案",
  "investor_150":"6.本公司111年度對「財團法人新北市私立八方雲集社會福利慈善事業基金會」捐贈新台幣三百萬元案",
  "investor_151":"1.擬增資子公司Bafang Yunji International (USA) Limited及再轉增資子公司Bafang Yunji Foods LLC及子公司Bafang Yunji Restaurant Group LLC案",
  "investor_152":"2.本公司擬於屯山廠增設冷凍調理包生產線案",
  "investor_153":"3.福建八方雲集食品有限公司及福建八方雲集餐飲管理有限公司結束營業案",
  "investor_154":"1.本公司更換簽證會計師案",
  "investor_155":"2.擬通過本公司111年第3季合併財務報表案",
  "investor_156":"3.擬訂定本公司「風險管理政策與程序」案",
  "investor_157":"4.擬訂定本公司「永續報告書編製及驗證之作業程序」案",
  "investor_158":"5.擬修訂本公司內部控制制度「電腦化資訊系統」案",
  "investor_159":"6.擬訂定本公司「內部重大資訊處理作業程序」",
  "investor_160":"7.擬修訂本公司「董事會議事規範」案",
  "investor_161":"8.擬訂定本公司112年度稽核計劃案",
  "investor_162":"無",
  "investor_163":"全體出席委員同意通過",
  "investor_164":"全體出席董事同意通過",
  "investor_165":"(二)除前開事項外，其他未經審計委員會通過，而經全體董事三分之二以上同意之議決事項：無此情事。",
  "investor_166":"(三)獨立董事對利害關係議案迴避之執行情形，應敘明獨立董事姓名、議案內容、應利益迴避原因以及參與表決情形：無此情事。",
  "investor_167":"會計師獨立性及適任性評估",
  "investor_167-1":"獨立性",
  "investor_167-2":"適任性",
  "investor_168":"評估內容",
  "investor_169":"項次",
  "investor_170":"否",
  "investor_171-1":"1",
  "investor_172-1":"2",
  "investor_173-1":"3",
  "investor_174-1":"4",
  "investor_175-1":"5",
  "investor_176-1":"6",
  "investor_177-1":"7",
  "investor_178-1":"8",
  "investor_179-1":"9",
  "investor_180-1":"10",
  "investor_1811-1":"11",
  "investor_171":"會計師無與本公司有直接或重大間接財務利益關係。",
  "investor_172":"會計師無與本公司或本公司董事有融資或保證行為。",
  "investor_173":"會計師無與本公司有重大密切之商業關係及潛在之僱傭關係。",
  "investor_174":"會計師及審計小組成員目前或最近二年無擔任本公司之董事、經理人或對審計案件有重大影響之職務。",
  "investor_175":"會計師對公司所提供之非審計服務無直接影響審計案件之重要項目。",
  "investor_176":"會計師無宣傳或仲介本公司所發行之股票或其他證券。",
  "investor_177":"會計師除依法令許可之業務外，無代表本公司與第三者間法律案件或其他爭議事項之辯護。",
  "investor_178":"會計師無與本公司之董事、經理人或對審計案件有重大影響職務之人員有親屬關係。",
  "investor_179":"卸任一年以內之共同執業會計師並無擔任本公司董事、經理人或對查核案件有重大影響之職務。",
  "investor_180":"會計師無收受本公司或其董事、經理人或主要股東價值重大之禮物餽贈或特別優惠。",
  "investor_181":"是",
  "investor_1811":"會計師任期無連續超過七年。",
  "investor_1711":"會計師事務所在處理公司審計服務上是否有足夠的規模、資源及區域覆蓋率?",
  "investor_1722":"會計師事務所是否有明確的品質控管程序，以確保財務報告之品質？ ",
  "investor_1733":"會計師事務所在外部檢查缺失及處分與主管機關發函改善無異常。",
  "investor_1744":"會計師事務所有提升審計品質之承諾，包括採行或規劃提升審計品質相關之倡議或計畫。",
  "investor_1755":"會計師事務所在風險管理、公司治理、財務會計及相關風險控制上是否及時通知董事會(審計委員會)任何顯著的問題及發展？",
  "investor_182":"薪資報酬委員會運作情形資訊",
  "investor_183":"1.薪酬委員會職責",
  "investor_184":"● 本公司自109年7月7日起正式設置薪資報酬委員會，主要職權如下：",
  "investor_184_1":"● 本公司於112年6月23日董事會通過委任第二屆薪資報酬委員會成員，成員由四位獨立董事擔任(請參見董事會成員介紹)。",
  "investor_185":"委員會以善良管理人之注意，忠實履行下列職權，並將所提建議提交董事會討論：",
  "investor_186":"一、定期檢討規程並提出修正建議。",
  "investor_187":"二、訂定並定期檢討本公司董事及經理人績效評估標準、年度及長期之績效目標，與薪資報酬之政策、制度、標準與結構，並於年報中揭露績效評估標準之內容。",
  "investor_188":"三、定期評估本公司董事及經理人之績效目標達成情形，並依據績效評估標準所得之評估結果，訂定其個別薪資報酬之內容及數額。年報中應揭露董事及經理人之個別績效評估結果，及個別薪資報酬之內容及數額與績效評估結果之關聯性及合理性，並於股東會報告。",
  "investor_189":"第二屆薪酬委員會任期：112年6月23日至115年6月14。最近年度(114年度)開會 5 次，委員出席情形如下：",
  "investor_190":"2.薪資報酬委員會運作情形",
  "investor_191":"● 本公司之薪資報酬委員會於109年07月07日成立，委員計4人，本屆委員任期：112年06月15日至115年06月14日，截至113年12月31日，已開會7次。113年度薪酬委員會共開會6次(A)，委員出列席情形如下：",
  "investor_192":"",//留空
  "investor_193":"召集人",
  "investor_194":"委員",
  "investor_195":"其他應記載事項：",
  "investor_196":"一、董事會如不採納或修正薪資報酬委員會之建議，應敘明董事會日期、期別、議案內容、董事會決議結果以及公司對薪資報酬委員會意見之處理:無此情事。",
  "investor_197":"二、薪資報酬委員會之議決事項，如成員有反對或保留意見且有紀錄或書面聲明者，應敘明薪資報酬委員會日期、期別、議案內容、所有成員意見及對成員意見之處理",
  "investor_198":"第一屆第二次",
  "investor_199":"第一屆第三次",
  "investor_200":"第一屆第四次",
  "investor_201":"110.01.29",
  "investor_202":"110.04.08",
  "investor_203":"110.07.20",
  "investor_204":"110.08.10",
  "investor_205":"110.11.10",
  "investor_206":"111.01.24",
  "investor_207":"111.03.22",
  "investor_208":"111.08.09",
  "investor_209":"111.10.07",
  "investor_210":"111.11.10",
  "investor_211":"發放經理人109年度年終獎金",
  "investor_212":"109年度員工酬勞及董事酬勞分配案",
  "investor_213":"1.訂定110年度現金增資員工認股辦法",
  "investor_214":"2.經理人於110年度現金增資員工認股情形",
  "investor_215":"3.修訂員工酬勞實施辦法",
  "investor_216":"本公司109年度員工酬勞發放案",
  "investor_217":"本公司109年度員工酬勞發放修正案",
  "investor_218":"發放經理人110年度年終獎金",
  "investor_219":"110年度員工酬勞及董事酬勞分配案",
  "investor_220":"本公司110年度員工酬勞發放案",
  "investor_221":"本公司經理人調整薪資報酬案",
  "investor_222":"評估檢討董事及經理人薪資報酬之政策、制度、標準與結構",
  "investor_223":"委員會決議結果",
  "investor_224":"公司對薪酬委員會意見之處理",
  "investor_225_1":"一、永續發展暨風險管理委員會-組織架構",
  "investor_225_2":"本公司於114年8月12日將原隸屬於董事會之「風險管理委員會」變更名稱為「永續發展暨風險管理委員會」，由6位董事組成，每年至少召開一次，協助董事會持續推動企業永續發展與風險治理。本公司策略長兼任永續長，由永續長組成跨部門之「永續發展推動與執行小組」，轄下設置以下任務編組負責執行並向公司治理室或本委員會提報執行成果。",
  "investor_225_3":"二、永續發展暨風險管理委員會-成員組成及具備能力",
  "investor_225_4":"(1)委員會組成",
  "investor_225_5":"永續發展暨風險管理委員會(原風險管理委員會)直接隸屬於董事會，由以下6位董事組成，其中過半數為獨立董事，並由獨立董事擔任主席。",
  "investor_225_6":"(2)成員永續專案知識及能力",
  "investor_225_7":"6位董事皆已具備永續專業知識與能力，永續相關董事進修情形摘要如下，",
  "investor_225_8":"三、永續發展暨風險管理委員會-職權角色",
  "investor_225_9":"永續發展暨風險管理委員會協助董事會推動企業永續發展與風險治理，履行下列職權並提報董事會。",
  "investor_225_10":"1.永續發展：",   
  "investor_225_11":"(1)制定、推動及強化公司永續發展政策、年度計畫及策略等。",
  "investor_225_12":"(2)檢討、追蹤與修訂永續發展執行情形與成效。",
  "investor_225_13":"(3)督導永續資訊揭露事項並審議永續報告書。",
  "investor_225_14":"(4)督導本公司永續發展守則之業務或其他經董事會決議之永續發展相關工作之執行。",
  "investor_225_15":"2.風險管理：",
  "investor_225_16":"(1)審查風險管理政策、程序與架構，並定期檢討其適用性與執行效能。",
  "investor_225_17":"(2)核定風險胃納(風險容忍度)，導引資源分配。",
  "investor_225_18":"(3)確保風險管理機制能充分處理公司所面臨之風險，並融合至日常營運作業流程中。",
  "investor_225_19":"(4)核定風險控管的優先順序與風險等級。",
  "investor_225_20":"(5)審查風險管理執行情形，提出必要之改善建議，並定期(至少一年1次)向董事會報告。",
  "investor_225_21":"(6)執行董事會之風險管理決策。",

  "investor_225_22":"六、114年度永續發展暨風險管理委員會(原風險管理委員會)運作情形：",
  "investor_225_23":"(1)風險管理運作與執行情形",
  "investor_225_24":"114年5月7日由風險管理推動與執行小組向風險管理委員會及董事會報告有關風險管理規劃與執行相關事務，並於11月11日將「114年度風險評量及因應策略」提報永續發展暨風險管理委員會審議及董事會報告。本公司面對各層面可能之風險，已訂定相關管理政策，且持續透過內部管理會議及不定期針對特定事件檢討，讓風險發生的可能性及影響降到最低。",
  "investor_225_25":"(2)董事會對永續發展之督導情形",
  "investor_225_26":"114年董事會督導永續資訊揭露、功能性委員會組織變更、永續長任命以及永續相關內控制度修正，並皆已經董事會討論決議通過。",
  "investor_225_27":"●113年永續報告書提請核准案",
  "investor_225_28":"●「風險管理委員會」更名為「永續發展暨風險管理委員會」，並修正本公司「風險管理委員會組織規程」為「永續發展暨風險管理委員會組織規程」及部分條文",
  "investor_225_29":"●本公司永續長委任案",
  "investor_225_30":"●擬修正本公司「永續發展實務守則」案",
  "investor_225_31":"●擬修正本公司「永續報告書編製及確信之作業程序」案",
  "investor_225_32":"此外，董事會定期聽取各項永續推動專案規劃及執行進度，包含ISO14001環境管理系統導入、ISO45001職業安全衛生管理系統導入、溫室氣體盤查及查證等，如有需要時則敦促經營團隊進行調整。",

  "investor_226":"風險管理組織",
  "investor_227":"職責",
  "investor_228":"董事會為風險管理之最高治理單位，負責公司整體風險之最終責任。",
  "investor_229":"風險管理委員會",
  "investor_230":"風險管理委員會直接隸屬董事會，由6位董事組成，其中過半數為獨立董事，並由獨立董事擔任主席。負責進行風險管理相關運作機制之監督，並定期(每年至少1次)向董事會報告風險管理執行情形。",
  "investor_2301":"第一屆風險管理委員會委員 (任期：112年6月23日-115年6月14日)",
  "investor_2311":"風險管理委員會職權如下：",
  "investor_231":"(1)	審查風險管理政策、程序與架構，並定期檢討其適用性與執行效能；",
  "investor_232":"(2)	核定風險胃納(風險容忍度)，導引資源分配；",
  "investor_233":"(3)	確保風險管理機制能充分處理公司所面臨之風險，並融合至日常營運作業流程中",
  "investor_234":"(4)	核定風險控管的優先順序與風險等級；",
  "investor_235":"(5)	審查風險管理執行情形，提出必要之改善建議，並定期向董事會報告；",
  "investor_236":"(6)	執行董事會之風險管理決策。",
  "investor_237":"稽核室",
  "investor_238":"稽核室依風險評估結果擬定年度計畫，內部控制體系部分，由稽核室評估個單位執行有關風險管理作業是否落實執行，確認各項作業風險均獲得有效管控，並適時提出改善建議。",
  "investor_239":"風險管理推動與執行小組",
  "investor_240":"以任務編組方式成立風險管理推動與執行小組，執行風險管理委員會之風險管理決策，負責規劃、執行與監督風險管理相關事務，並協助推動企業風險管理文化。風險管理推動與執行小組由總經理任命總管理處主管兼任，小組成員由本公司各單位相關主管組成，並定期向風險管理委員會提報公司風險管理執行情形報告。",
  "investor_241":"各單位",
  "investor_242":"各單位主管負有風險管理之責任，負責風險辨識、分析及監控所屬單位內之相關風險，確保風險管理機制與程序能有效執行。",
  "investor_243":"四、風險管理政策與程序",
  "investor_244":"本公司為持續強化公司治理並健全風險管理作業，董事會於111年11月10日通過「風險管理政策與程序」，作為本公司風險管理之最高指導原則。本政策涵蓋管理目的、風險範圍、組織架構與職責、管理程序、風險類型、風險管理之運作與執行落實之評估，將業務活動所產生的風險控制在可接受的範圍，以合理確保公司目標之達成與企業永續經營與發展。董事會為風險管理之最高治理單位，負責公司整體風險之最終責任，永續發展暨風險管理委員會依職責推動風險治理，稽核室依風險評估結果擬定年度計畫，確認各項作業風險均獲得有效管控，並適時提出改善建議。",
  "investor_245":"五、風險管理的範疇",
  "investor_246":"本公司的風險管理範疇包括「策略與經營風險」、「市場風險」、「食安風險」、「資訊風險」、「法遵風險」、「財務風險」、「環境風險」、以及凡與本公司產品及生產、服務的過程有關的活動等之風險管理皆涵蓋。",
  "investor_247":"風險管理運作與執行情形",
  "investor_248":"113年5月8日、8月7日及11月6日由風險管理推動與執行小組向風險管理委員會報告有關規劃與執行風險管理相關事務，並於同年11月6日向董事會呈報113年度風險評量及因應策略。本公司面對各層面可能之風險，已訂定相關管理政策，且持續透過內部管理會議及不定期針對特定事件檢討，讓風險發生的可能性及影響降到最低。",
  "investor_249":"設置公司治理主管",
  "investor_250":"本公司112年6月23日於董事會決議設置公司治理主管，現由公司治理室鄭秋治協理擔任，其辦理薪酬委員會相關事務已達三年以上，符合於證券、金融、期貨相關機構或公開發行公司從事法務、財務、法令遵循、內部稽核、股務或第21條所定公司治理相關事務單位之主管職務達三年以上之規範。",
  "investor_251":"相關學經歷及112年度進修資訊如下：",
  "investor_252":"鄭秋治 總管理處協理",
  "investor_253":"學歷：元智大學企研所",
  "investor_254":"經歷：",
  "investor_255":"八方雲集國際股份有限公司總管理處 協理",
  "investor_256":"人力資源部、總經理室、行銷企劃部、公關客服部 經理",
  "investor_257":"業務直營部、業務訓練部 副理",
  "investor_258":"序號",
  "investor_259":"主辦單位",
  "investor_260":"課程名稱",
  "investor_261":"進修期間",
  "investor_262":"進修時數",
  "investor_263":"當年度進修總時數",
  "investor_264":"起",
  "investor_265":"迄",
  "investor_266":"財團法人中華民國證券暨期貨市場發展基金會",
  "investor_267":"社團法人中華公司治理協會",
  "investor_268":"財團法人中華民國證券暨期貨市場發展基金會",
  "investor_269":"社團法人中華公司治理協會",
  "investor_270":"社團法人中華公司治理協會",
  "investor_271":"社團法人中華公司治理協會",
  "investor_272":"臺灣證券交易所、證券櫃檯買賣中心",
  "investor_273":"臺灣證券交易所",
  "investor_274":"112年度內部人股權交易法律遵循宣導說明會",
  "investor_275":"企業經營及輿論新聞危機管理策略",
  "investor_276":"112年度防範內線交易宣導會",
  "investor_277":"從案例介紹經營權爭奪下的董事會及股東會程序爭議",
  "investor_278":"董事會績效評估實務分享研討會",
  "investor_279":"經營權與董事責任研討會",
  "investor_280":"112年上市櫃公司永續發展行動方案宣導會",
  "investor_281":"2023國泰永續金融暨氣候變遷高峰論壇",
  "investor_282":"112/11/22",
  "investor_283":"112/11/09",
  "investor_284":"112/10/13",
  "investor_285":"112/08/10",
  "investor_286":"112/07/26",
  "investor_287":"112/07/20",
  "investor_288":"112/07/04",
  "investor_289":"3小時",
  "investor_290":"6小時",
  "investor_291":"27小時",
  "investor_292":"公司治理運作情形",
  "investor_293":"公司治理運作情形即與上市上櫃公司治理實務守則差異情形及原因",
  "investor_294":"評估項目",
  "investor_295":"運作情形",
  "investor_296":"與上市上櫃公司治理實務守則差異情形及原因",
  "investor_297":"是",
  "investor_298":"否",
  "investor_299":"摘要說明",
  "investor_300":"一、公司是否依據「上市上櫃公司治理實務守則」訂定並揭露公司治理實務守則？",
  "investor_301":"為建立本公司良好之公司治理制度，已參酌「上市上櫃公司治理實務守則」訂定本公司之「公司治理實務守則」，於110年1月29日董事會通過，並配合法令，於111年1月24日及112年1月17日董事會通過修訂「公司治理實務守則」，於公開觀測資訊站與本公司網站揭露。",
  "investor_302":"與治理實務守則之原則無重大差異。",
  "investor_303":"二、公司股權結構及股東權益",
  "investor_304":"(一)公司是否訂定內部作業程序處理股東建議、疑義、糾紛及訴訟事宜，並依程序實施？",
  "investor_305":"(二)公司是否掌握實際控制公司之主要股東及主要股東之最終控制者名單？",
  "investor_306":"(三)公司是否建立、執行與關係企業間之風險控管及防火牆機制？",
  "investor_307":"(四)公司是否訂定內部規範，禁止公司內部人利用市場上未公開資訊買賣有價證券？",
  "investor_308":"本公司為確保股東權益，訂定「股東會議事規則」，設有發言人、代理發言人及股務信箱外，本公司亦委託專業股務代理機構「中國信託商業銀行股份有限公司」代理部處理股東之相關問題及建議，若涉及法律問題，則將委請專業律師或法務人員進行處理。",
  "investor_309":"本公司設有股務人員管理相關資訊，並委任專責股務代理機構協助處理股務相關事宜，掌握實際控制公司之主要股東及主要股東之最終控制者名單。",
  "investor_310":"本公司與各子公司間之財務、業務均獨立運作，並受本公司控管與稽核。本公司訂有「關係人交易管理辦法」，與關係企業經營、業務及財務往來皆有明確規範，已達風險控管機制。",
  "investor_311":"本公司已訂定「防範內線交易管理辦法」規範。本公司並一年至少一次以上進行教育訓練，提醒內部人有關內線交易之相關規範。",
  "investor_312":"無重大差異",
  "investor_313":"三、董事會之組成及職責",
  "investor_314":"(一)董事會是否擬訂多元化政策、具體管理目標及落實執行？",
  "investor_315":"(二)公司除依法設置薪資報酬委員會及審計委員會外，是否自願設置其他各類功能性委員會？",
  "investor_316":"(三)公司是否訂定董事會績效評估辦法及其評估方式，每年並定期進行績效評估，且將績效評估之結果提報董事會，並運用於個別董事薪資報酬及提名續任之參考？",
  "investor_317":"(四)公司是否定期評估簽證會計師獨立性？",
  "investor_318":"本公司「董事選任程序」中明訂董事會成員組成應考量多元化，就本身運作、營運型態及發展需求來作整體配置，包括但不限於性別、年齡、國籍、文化及專業知識技能。本公司第四屆董事會依據公司章程設置9席董事(現有8席，其中含2席女性董事)，且董事會成員各自擁有不同商務、法務、財務、科技及產業等相關專業經驗背景，董事組成具有多元化且符合公司發展需求。",
  "investor_319":"本公司除設置薪資報酬委員會及審計委員會外，將視需要評估設置其他各類功能性委員會。",
  "investor_320":"本公司已訂定「董事會績效評估辦法」，以落實公司治理並提升本公司董事會功能，建立績效目標以加強董事會運作效率。111年度之績效評估結果已於112年第一季完成，並提報112年3月23日董事會。",
  "investor_321":"依據本公司公司治理實務守則第29條規定，每年應定期(至少一年一次)評估聘任會計師之獨立性及適任性，本公司除要求簽證會計師提供「獨立性聲明」及「審計品質指標AQIs」，並參考AQI 報告內容包括專業性、品質控管、獨立性、監督、創新能力等 5 大構面及 13 項指標及附表一標準進行評估。最近一年度評估結果業經112年3月23日董事會決議通過，均符合本公司獨立性及適任性評估標準。",
  "investor_322":"四、上市上櫃公司是否配置適任及適當人數之公司治理人員，並指定公司治理主管，負責公司治理相關事務(包括但不限於提供董事、監察人執行業務所需資料、協助董事、監察人遵循法令、依法辦理董事會及股東會之會議相關事宜、製作董事會及股東會議事錄等)？",
  "investor_323":"五、公司是否建立與利害關係人(包括但不限於股東、員工、客戶及供應商等)溝通管道，及於公司網站設置利害關係人專區，並妥適回應利害關係人所關切之重要企業社會責任議題？",
  "investor_324":"六、公司是否委任專業股務代辦機構辦理股東會事務？",
  "investor_325":"本公司已設置專人負責提供董事、審計委員會委員執行業務所需資料、協助董事、審計委員會委員遵循法令、依法辦理董事會及股東會之會議相關事宜、製作董事會及股東會議事錄等。",
  "investor_326":"本公司設有發言人及代理發言人，作為利害關係人溝通管道，並於本公司官網及公開資訊觀測站上均設有聯絡方式及信箱，可以提供給利害關係人隨時聯繫。",
  "investor_327":"本公司已委託中國信託代理部代辦機構辦理股東會及相關事務。",
  "investor_328":"七、資訊公開",
  "investor_329":"(一)公司是否架設網站，揭露財務業務及公司治理資訊？",
  "investor_330":"(二)公司是否採行其他資訊揭露之方式（如架設英文網站、指定專人負責公司資訊之蒐集及揭露、落實發言人制度、法人說明會過程放置公司網站等）？",
  "investor_331":"(三)公司是否於會計年度終了後兩個月內公告並申報年度財務報告，及於規定期限前提早公告並申報第一、二、三季財務報告與各月份營運情形？",
  "investor_332":"本公司已架設企業網站揭露財務業務及公司治理等相關資訊，並由專人負責，並透過與公開資訊觀測站連結，以利資訊即時更新及揭露。",
  "investor_333":"本公司設有專人負責資訊之蒐集及揭露，並已設置發言人及代理發言人制度，並將法人說明會過程放置公司網站。",
  "investor_334":"本公司依規定於期限內公告並申報年度財務報告，第一、二、三季財務報告與各月份營運情形。",
  "investor_335":"未來視需要評估提前公告及申報",
  "investor_336":"八、公司是否有其他有助於瞭解公司治理運作情形之重要資訊(包括但不限於員工權益、僱員關懷、投資者關係、供應商關係、利害關係人之權利、董事及監察人進修之情形、風險管理政策及風險衡量標準之執行情形、客戶政策之執行情形、公司為董事及監察人購買責任保險之情形等)？",
  "investor_337":"(一)員工權益：成立職工福利委員會、實施退休金、投保員工團體保險等措施。",
  "investor_338":"(二)僱員關懷：除依相關法令辦理外，另提供同仁結婚補助、同仁子女結婚禮金、同仁生育獎勵金、子女教養補助、同仁暨眷屬喪葬給付等福利。依規成立職工福利委員會，提撥福利金，辦理如員工旅遊暨健康檢查補助、生日禮金、醫療急難救助貸款等員工福利事務。",
  "investor_339":"(三)投資者關係：依相關法令規定揭露財務業務、重大訊息等資訊於公開資訊觀測站，供投資人了解，並建立發言人制度妥善處理投資人各項詢問，維持與投資者良好關係。",
  "investor_340":"(四)供應商關係：本公司依平等互惠原則與供應商建立夥伴關係，且不定期進行稽核，建立食品安全供應鏈。",
  "investor_341":"(五)利害關係人之權利：揭露財務業務、重大訊息等資訊於公開資訊觀測站，供利害關係人了解。",
  "investor_342":"(六)董事進修之情形：本公司董事均具有專業背景，且本公司以積極之態度安排董事參與進修，111年度已針對董事辦理課程，請參閱以下附表二。",
  "investor_343":"(七)風險管理政策及風險衡量標準之執行情形：本公司董事會已於111年通過「風險管理政策與程序」，對於風險管理已依相關規範建立適當之政策、程序及內部控制，重要財務活動需經董事會依相關規範及內部控制制度進行覆核。",
  "investor_344":"(八)客戶政策之執行情形：秉持消費者至上之經營理念，堅持提供「安全、新鮮、美味、平價」之產品。",
  "investor_345":"(九)公司為董事及經理人購買責任保險之情形：本公司已於111年8月6日為董事及經理人進行投保。",
  "investor_346":"(十)董事會成員及重要管理階層之接班計劃：本公司「公司章程」中載明定董事選舉應採候選人提名制度，並訂有「公司治理實務守則」及「董事選任程序」，明訂董事會成員組成應考量多元化，並就公司本身運作、營運型態及發展需求以擬訂適當之多元化方針，宜包括但不限於基本條件與價值、專業知識技能等兩大面向之標準。",
  "investor_347":"目前董事設置9名(現任8名，包含4名獨立董事)，具備多元互補之產業經驗及金融、財務、會計、法律及資訊等專業能力。現任董事成員中1人兼任本公司高階管理階層。",
  "investor_348":"關於董事會之接班規劃，本公司培育高階經理人進入董事會，使其熟悉董事會運作及公司各單位業務，並透過工作輪調方式深化其產業經驗。目前公司尚有多位高階管理人才，具充沛之人才庫可以選任為未來之董事。除考量多元化，兼任公司經理人之董事不逾董事席次三分之一，並將注重性別平等，具備執行職務所必須之知識、技能及素養。",
  "investor_349":"重要管理階層",
  "investor_350":"1.接班計劃：本公司自111年起每年檢視公司重要管理職位的接班人才庫狀況，並依據檢視成果，規劃各團隊的培養計畫。",
  "investor_351":"2.運作情形：自111年起，每年各單位最高主管皆針對其單位中的重要管理職位的接班人才狀況做全盤檢視及規劃。擔任重要管理職位人員，需對其所屬職能擬定接班人，無接班人者提出鍛鍊內部合適之接班人選，或尋找外部人才加入公司等規劃。並需針對預計接班人升遷到管理階層的潛力進行評估，並搭配合適之培訓計畫及教育訓練，針對管理職能進行培育並歷練專案計劃之執行。",
  "investor_352":"總經理是本公司營運發展最關鍵的人物，必須對公司及產業都具有長期經驗且了解市場脈動，方能進行完整規劃並帶領公司發展。現任總經理張瑞蓮女士，自民國98年加入本公司，先後擔任財務長及執行副總，帶領公司財務、營運及業務發展等相關事務，於106年2月晉升總經理。",
  "investor_353":"九、請就臺灣證券交易所股份有限公司公司治理中心最近年度發布之公司治理評鑑結果說明已改善情形，及就尚未改善者提出優先加強事項與措施。(未列入受評公司者無需填列)：",
  "investor_354":"本公司111年首度參與「公司治理評鑑」，針對治理評鑑結果預計改善加強事項說明如下：",
  "investor_355":"(一)維護股東權益及平等對待股東：",
  "investor_356":"1.過半數董事會及審計委員會召集人親自出席股東常會：將積極協調董事、獨立董事出席股東常會。",
  "investor_357":"(二)強化董事會結構與運作：",
  "investor_358":"1.公司已於111年11月10日通過本公司「風險管理政策與程序」，並預定於112年設置「風險管理委員會」及公司治理主管。",
  "investor_359":"2.本公司已針對重要管理階層之接班規劃，盤點具潛力之接班人，擬定個人發展規劃並予以培訓。",
  "investor_360":"(三)提升資訊透明度：",
  "investor_361":"1.自112年起同步申報英文重大訊息。",
  "investor_362":"2.112年底前完成英文網站建置。",
  "investor_363":"(四)落實企業責任：",
  "investor_364":"1.已設置推動誠信經營之單位，並於112年安排向董事會報告。",
  "investor_365":"(2)會計師與獨立董事之溝通",
  "investor_366":"114年會計師除參與各季與財務報表議案相關之審計委員會及董事會報告查核或核閱結果外，已分別於3月13日及11月11日與審計委員會單獨的溝通討論。",
  "investor_367":"114/03/13",
  "investor_368":"114/11/11",
  "investor_369":"勤業眾信 會計師李麗凰",
  "investor_370":"勤業眾信 協理黃咸琛",
  "investor_371":"出席人員",
  "investor_372":"溝通事項",
  "investor_373":"溝通結果",
  "investor_374":"勤業眾信 會計師李麗凰",
  "investor_375":"溝通報告113年度財務報告最終查核範圍、查核的調整、關鍵查核事項、與管理階層討論之重大事項及查核結論等查核結論事項",
  "investor_376":"溝通114年度財務報告查核目標、集團查核範圍、顯著風險辨認及預計執行程序、關鍵查核事項等查核規劃",
  "investor_377":"結論：就113年度財務報告查核結論事項無異議。",
  "investor_378":"結論：就114年度財務報告查核規劃事項無其他建議。",
  "investor_379":"",
  "investor_380":"",
  "investor_381":"",
  "investor_382":"",
  "investor_383":"",
  "investor_384":"",
  "investor_385":"",
  "investor_386":"",
  "investor_387":"無異議照案通過",
  "investor_388":"落實誠信經營",
  "investor_389":"",//留空
  "investor_390":"本公司已訂定「誠信經營守則」及「誠信經營作業程序及行為指南」並經董事會通過，作為公司誠信經營之政策及作業指導原則。「誠信經營作業程序及行為指南」中，已辨識營業範圍中較可能發生不誠信行為風險之營業活動，並已訂定相關作業規則「誠信違反檢舉作業辦法」。另本公司工作規則明訂員工應本著「誠、正、信、實」的工作態度善盡職責，嚴禁直接或間接提供、承諾、要求或收受任何不正當利益，或做出其他違反誠信、不法或違背受託義務之不誠信行為。",
  "investor_391":"誠信經營之宣導",
  "investor_392":"本公司透過定期經理月會進行各項宣導(含營運及誠信經營層面、食品安全衛生管理等相關內容)。此外，本公司亦訂有誠信經營相關辦法，並每年度定期向同仁宣導誠信原則以提升法律遵循意識，降低不誠信行為之風險。",
  "investor_393":"誠信經營專責單位",
  "investor_394":"本公司設置隸屬於董事會之企業誠信經營專責單位為公司治理室法務主管，辦理企業誠信經營作業程序及其行為指南之修訂、執行、解釋、諮詢服務暨通報內容登錄建檔等相關作業及監督執行，並於114年11月11日已向董事會報告。",
  "investor_395":"履行誠信經營情形及採行措施",
  "investor_396":"履行誠信經營情形及與上市上櫃公司誠信經營守則差異情形及原因",
  "investor_397":"114年度教育訓練-誠信經營管理宣導",
  "investor_398":"●本公司已於114年10月進行年度誠信經營線上訓練課程，內容包含商業夥伴的誠信期許與管理策略、公司誠信經營管理制度宣導等內容。課程時數20分鐘/人，參與人數122人，總時數40.7小時。",
  "investor_399":"",
  "investor_400":"●10月11日對國際員工舉辦「禁止內線交易宣導說明」。(上一年度為111年12月13日)",
  "investor_401":"蕭玉娟",
  "investor_402":"第二屆第一次",
  "investor_403":"112.01.17",
  "investor_404":"112.03.23",
  "investor_405":"112.08.10",
  "investor_406":"發放經理人111年度年終獎金",
  "investor_407":"1.111年度員工酬勞及董事酬勞分配案",
  "investor_408":"2.本公司晉升經理人暨調整薪資報酬案",
  "investor_409":"1.111年度員工酬勞發放案",
  "investor_410":"2.本公司晉升經理人及調整經理人薪資報酬案",
  "investor_411":"",
  "investor_412":"",
  "investor_413":"",
  "investor_414":"",
  "investor_415":"",

  "investor_416":"本公司已訂定「誠信經營守則」及「誠信經營作業程序及行為指南」 並經董事會通過，作為公司誠信經營之政策及作業指導原則。",
  "investor_417":"本公司於「誠信經營作業程序及行為指南」中，已辨識營業範圍中較可能發生不誠信行為風險之營業活動，並已訂定相關作業規則。另本公司工作規則明訂員工應本著「誠、正、信、實」的工作態度善盡職責，嚴禁直接或間接提供、承諾、要求或收受任何不正當利益，或做出其他違反誠信、不法或違背受託義務之不誠信行為。",
  "investor_418":"本公司已訂定「誠信經營守則」及「誠信經營作業程序及行為指南」，明訂防範不誠信行為相關制度與程序。本公司全體九席董事及公司經理人(協理級以上)皆已簽署誠信聲明書，落實誠信經營方針。另公司為加強宣導誠信原則，除於公司的官網內明示本公司企業精神之內涵，111年對八方雲集總公司(含餐飲子公司、丹堤子公司)公司員工進行：(1)誠信經營、(2)資通安全、(3)防範內線交易及(4)食品安全方面的教育訓練，總訓練人次共746人次，總訓練時數共855小時，以期提升同仁品德觀念，建立良好的企業文化，並以相同的水準要求往來之供應商、客戶。",
  "investor_419":"本公司誠信經營守則已具體規範本公司人員，於從事商業行為之過程中，不得直接或間接提供、承諾、要求或收受任何不正當利益，或做出其他違反誠信、不法或違背受託義務之行為。另於往來供應商合約亦明載誠信聲明書及違反誠信之相關處理方式。",
  "investor_420":"本公司設置隸屬於董事會之企業誠信經營專責單位為總經理室法務主管，辦理企業誠信經營作業程序及其行為指南之修訂、執行、解釋、諮詢服務暨通報內容登錄建檔等相關作業及監督執行，並定期向董事會報告。",
  "investor_421":"本公司董事、經理人及其他出席或列席董事會之利害關係人對董事會所列議案，與其自身或其代表之法人有利害關係者，應於當次董事會說明其利害關係之重要內容，如有害於公司利益之虞時，不得加入討論及表決，且討論及表決時應予迴避，並不得代理其他董事行使其表決權。",
  "investor_422":"本公司為確保誠信經營之落實，訂有「誠信經營守則」及「誠信經營作業程序及行為指南」以茲遵循，防範不誠信行為發生，並建立有效之會計制度及內部控制制度，公司內部稽核單位定期查核各項制度遵循情形，並作成稽核報告提報董事會。",
  "investor_423":"本公司定期對員工舉辦誠信經營教育訓練與宣導，董事長、總經理或高階管理階層亦不定期向員工傳達誠信之重要性，使其充分瞭解公司誠信經營之決心、政策、防範方案及實施不誠信行為之後果。",
  "investor_424":"本公司接受任何不法或不道德情事之通報，設有專門信箱，直接由法務主管受理，並對檢舉人身分及檢舉內容確實保密。",
  "investor_425":"本公司對檢舉人之身分及檢舉內容保密，並保護檢舉人不因檢舉而遭受不當處置之措施。",
  "investor_426":"本公司已訂定「誠信經營守則」、「誠信經營作業程序及行為指南」及「誠信違反檢舉作業辦法」，並揭露於公司網站及公開資訊觀測站。本公司並於股東會年報及網站揭露誠信經營執行情形。",
  "investor_427":"違反誠信檢舉窗口",
  "investor_428":"本公司訂有「誠信違反檢舉作業辦法」，對於建立誠信、透明的企業文化及促進健全經營等議題非常重視，如您發現本公司人員有違反誠信之事實時，可透過下列管道提出檢舉。",
  "investor_429":"檢舉方式及管道",
  "investor_430":"電子信箱：",
  "investor_431":"信件地址︰251新北市淡水區中正東路二段27號18樓 法務主管親啟",
  "investor_432":"檢舉人須知",
  "investor_433":"為加速案件之受理及調查，惠請檢舉人提供「檢舉函」所需內容或以該函逕行提出供本公司查證。如有下列情形，本公司得不予受理。",
  "investor_434":"檢舉人未檢附可供調查之具體事證。",
  "investor_435":"檢舉內容屬惡意攻訐、虛偽不實或顯無理由者。",
  "investor_436":"對檢舉人的保護",
  "investor_437":"本公司受理、調查及其他參與檢舉案件處理的人員，對於檢舉人的身分及檢舉案件的內容，均負有保密義務。",
  "investor_438":"本公司不因所屬人員提出檢舉或協助他人檢舉而對其為不利對待或處分。惟檢舉案件經調查發現內容不實且涉及對本公司或本公司人員惡意攻訐者則不適用。",
  "investor_439":"檢舉表單下載",
  "investor_440":"資訊安全政策",
  "investor_441":"本公司持續強化資訊安全管理，確保資訊的機密性、完整性與可用性。資訊設備（包括電腦硬體、軟體、週邊）與網路系統之可靠性以及加強同仁對資訊安全之認知，並保護上述資源免受任何因素之干擾、破壞、入侵、或任何不利之行為與企圖，以維持業務持續運作 。",
  "investor_442":"資訊安全組織",
  "investor_443":"本公司在資安經理持續推動公司內部組織恪遵各項資安規定以達到內部控制最佳化，特於114年9月至各工廠進行資安稽查，以彰顯管理階層對資安管理制度的重視及支持，持續推動管理制度有效並穩健的運作。目前資訊安全推動組設置2人，由總經理擔任召集人，策略長擔任副召集人每月召開1次資訊安全檢討會議及每年召開1次管理審查會議。資訊安全執行小組16人由資訊長擔任組長，依照資安規範調整資源以利推動資訊日常作業及執行資訊安全規範所定之工作，以提昇整體資安防護能量。資訊安全稽核小組1人由資安經理擔任組長，協助召集人確認各項資安作業依照規範進行查核。",
  "investor_444":"",
  "investor_445":"資訊安全風險控制",
  "investor_446":"本公司積極規劃部署資訊安全措施，不斷改善資訊安全環境，降低資訊安全風險。管理上從政策制度、組織職責、人力安全、資訊資產和風險管理、端末設備存取控制與管理、實體環境、通訊安全、系統開發與維護、營運持續管理、供應商關係管理、法規遵循性等方面制訂相關管理規範；技術上部署網路防火牆、應用程式防火牆、入侵防護系統、病毒防護系統、特權管理系統及資產管理系統等，計劃導入機敏資料保護系統預定115年推廣實施。每年均有安排外部稽核人員對公司資訊安全管理系統進行稽核，且針對資安運作狀況、風險控制及事件改善等進行審查，並將審查結果呈報至資訊安全推動組以控制資安風險在可接受的範圍內。",
  "investor_446_1":"",
  "investor_447":"員工資訊安全意識",
  "investor_448":"本公司為落實資訊安全觀念至每一位員工，資安室透過社交工程演練，模擬駭客的釣魚郵件，檢測員工資安風險意識，來提昇同仁對於資安的意識及警覺性。本公司針對員工進行基本的資訊安全教育訓練，對在職人員通過定期的資安教育訓練、資安宣導強化員工的資安意識。對內部資訊安全稽核發現的問題，透過矯正預防流程即時進行資訊安全管控，強化公司資訊安全成熟度。114年本公司資訊安全教育訓練計602人次(含香港子公司58人次)，上課總時數為699小時(含香港子公司58小時) ，並持續推動資安教育訓練及資安宣導作業。",
  "investor_449":"本公司針對員工進行基本的資訊安全教育訓練。對在職人員通過定期的資安教育訓練、影片宣導強化員工的資安意識。對內部資訊安全稽核發現的問題，透過矯正預防流程即時進行資訊安全管控，強化公司資訊安全成熟度。",
  "investor_450":"災難復原演練",
  "investor_451":"為確保公司重要業務的永續運作，門市管理系統已全面上線，為避免重要資訊系統因重大災難事件而導致服務無法持續的風險，本公司每年定期進行災難復原演練，提昇公司在關鍵時刻從容處理災難應變能力，以災害復原機制快速回復至企業正常或可接受的營運水準，以達到關鍵應用系統能持續運作並確保企業的營運不中斷。今年針對梁社漢官網個資外洩、門市管理系統資料庫進行還原演練。",
  "investor_452":"本公司每年至少一次對董事、經理人及受僱人辦理「防範內線交易管理作業程序」及內部重大訊息及相關法令之教育宣導。針對新任董事、經理人及受僱人適時提供教育宣導。",
  "investor_453":"本年度已於114年8月12日對現任董事進行教育宣導，課程內容包括內線交易法規及實務案例，共計8人次，總時數2小時。",
  "investor_454":"本年度已於114年12月18日對內部人進行教育宣導，課程內容包括內線交易法規及實務案例，共計17人次，總時數4.25小時。114年12月19日對台北辦公室員工舉辦禁止內線交易宣導說明，共計38人次，總時數9.5小時。",
  "investor_455":"本公司以電子郵件提醒董事及相關內部人不得於年度財務報告公告前三十日，和每季財務報告公告前十五日之封閉期間，以及重大消息公開後18小時內交易其股票。",
  "investor_456":"年度：",
  "investor_457":"(單位：新台幣仟元)",
  "investor_458":"合併營收",
  "investor_459":"營收金額",
  "investor_460":"年度增減比率",
  "investor_461":"一月",
  "investor_462":"二月",
  "investor_463":"三月",
  "investor_464":"四月",
  "investor_465":"五月",
  "investor_466":"六月",
  "investor_467":"七月",
  "investor_468":"八月",
  "investor_469":"九月",
  "investor_470":"十月",
  "investor_471":"十一月",
  "investor_472":"十二月",
  "investor_473":"本年累計",
  "investor_474":"說明",
  "investor_475":"檔案",
  "investor_476":"112年Q3合併財務報告",
  "investor_477":"112年Q2合併財務報告",
  "investor_478":"112年Q1合併財務報告",
  "investor_479":"111年度合併財務報告",
  "investor_480":"111年度個體財務報告",
  "investor_481":"111年Q3合併財務報告",
  "investor_482":"111年Q2合併財務報告",
  "investor_483":"111年Q1合併財務報告",
  "investor_484":"110年度合併財務報告",
  "investor_485":"110年度個體財務報告",
  "investor_486":"110年Q3合併財務報告",
  "investor_487":"110年Q2合併財務報告",
  "investor_488":"110年Q1合併財務報告",
  "investor_489":"109年Q2合併財務報告",
  "investor_490":"109年度合併財務報告",
  "investor_491":"109年度個體財務報告",
  "investor_492":"營益分析表",
  "investor_493":"財務分析資料",
  "investor_494":"*以上資訊連結公開資訊觀測站*",
  "investor_495":"持股比例占前十名之股東、持數額及比例",
  "investor_496":"114年4月12日",
  "investor_497":"主要股東名稱",
  "investor_498":"持有股數(股)",
  "investor_499":"持股比例(%)",
  "investor_500":"富御投資股份有限公司",
  "investor_501":"蘇淑幸",
  "investor_502":"林宜嫻",
  "investor_503":"林宜臻",
  "investor_504":"復興資本有限合夥",
  "investor_505":"匯豐(台灣)商業銀行股份有限公司受託保管ABS直接股權基金有限責任公司投資專戶",
  "investor_506":"林御政",
  "investor_507":"劉旭鈞",
  "investor_508-1":"吳敏哲",
  "investor_508":"股東會相關資料",
  "investor_509":"112年度",
  "investor_510":"111年度",
  "investor_511":"年報",
  "investor_512":"開會通知",
  "investor_513":"議事手冊",
  "investor_514":"議事錄",
  "investor_515":"110年度",
  "investor_516":"109年度",
  "investor_517":"*查詢其他相關資料請至",
  "investor_518":"公開觀測站",
  "investor_519":"，輸入公司代號：2753*",
  "investor_520-2":"股利所屬年(季)度：114年度",
  "investor_520-1":"股利所屬年(季)度：113年度",
  "investor_520":"股利所屬年(季)度：112年度",
  "investor_521":"股利所屬年(季)度：111年度",
  "investor_522":"股利所屬年(季)度：110年度",
  "investor_523":"股利所屬年(季)度：109年度",
  "investor_524":"以上資訊連結公開資訊觀測站",
  "investor_525":"*查詢歷史資料請連結",
  "investor_526":"公開觀測站",
  "investor_527":"，輸入公司代號：2753",
  "investor_528":"",//留空
  "investor_529":"時間",
  "investor_530":"說明",
  "investor_531":"簡報下載",
  "investor_5325":"受邀參加凱基證券舉辦之法人說明會",
  "investor_5324":"2025-12-19",
  "investor_5323":"2025-07-11",
  "investor_5322":"2024-12-06",
  "investor_5321":"2024-05-15",
  "investor_532":"2023-12-06",
  "investor_533":"2023-03-29",
  "investor_534":"2022-11-22",
  "investor_535":"2022-09-13 ~ 09-15",
  "investor_536":"2022-08-17",
  "investor_537":"2021-08-12",
  "investor_5382":"受邀參加統一證券舉辦之2024Q4全球展望冬季投資論壇",
  "investor_5381":"受邀參加國泰證券舉辦之法人說明會",
  "investor_538":"受邀參加統一證券舉辦之2023Q4全球展望冬季投資論壇",
  "investor_539":"受邀參加元大證券舉辦之法人說明會",
  "investor_540":"受邀參加國泰證券舉辦之線上法人說明會",
  "investor_541":"受邀參加台灣董事學會、臺灣證券交易所及安擘諮詢共同舉辦之2022線上數位引資論壇",
  "investor_542":"受邀參加凱基證券舉辦之線上法人說明會",
  "investor_543":"上市前業績發表會",
  "investor_544":"本公司盈餘分派或虧損撥補於每半會計年度終了後為之，每半會計年度決算後如有盈餘，應先提繳稅款、彌補累積虧損，次提10%為法定盈餘公積，但法定盈餘公積累積已達本公司實收資本額時，得不再提列，其餘再依法令或主管機關規定提撥或迴轉特別盈餘公積，如尚有盈餘，其餘額再加計上半會計年度累計未分配盈餘數，由董事會擬具分派議案。以發行新股方式為之時，應提請股東會決議後分派之；以現金方式為之時，應經董事會決議。",
  "investor_545":"本公司年度總決算如有盈餘，應先提繳稅款、彌補歷年累積虧損，次提10%為法定盈餘公積，但法定盈餘公積已達本公司實收資本額時，得不再提列，其餘再依法令或主管機關規定提撥或迴轉特別盈餘公積，如尚有盈餘，其餘額再加計累計未分配盈餘，由董事會擬具分派議案，以發行新股方式為之時，應提請股東會決議後分派之。",
  "investor_546":"本公司依公司法規定，授權董事會以三分之二以上董事之出席，及出席董事過半數之決議，將應分派股息及紅利或公司法第二百四十一條第一項規定之法定盈餘公積及資本公積之全部或一部，以發放現金之方式為之，並報告股東會。",
  "investor_547":"本公司處於企業成長階段，股利政策係依據公司營運發展不同階段、獲利狀況、公司中長期財務資本預算規劃，並兼顧股東權益等因素，適度採股票股利或現金股利方式發放。每年就可供分配盈餘提撥不低於20%作為股東股利，其中現金股利之比率不低於股利總數之20%。",
  "investor_548":"資訊安全管理方針",
  "investor_549":"本公司自112年正式導入ISO27001:2013年版資訊安全管理系統（ISMS），並於同年9月正式取得國際驗證機構SGS台灣檢驗科技公司的專業稽核團隊驗證，展現本公司對資訊安全治理的高度重視。113年SGS持續進行系統有效性複查，驗證結果再次肯定了本公司在資安管理上的專業與承諾。為持續符合最新國際規範，本公司已於114年完成 ISO 27001:2022 轉版作業並確保其證書的持續有效性，以及本公司資安管理架構與國際標準同步接軌。ISO 27001 為全球最具代表性的資訊安全管理國際標準。通過此驗證，代表本公司在制度建置、系統運作、流程管控與防禦措施等各層面，均已達到國際要求。本公司亦持續推動 P-D-C-A 循環 (Plan-Do-Check-Act)，確保資訊安全之機密性、完整性與可用性，並將資安納入營運風險管理核心。本公司深信，資訊安全不僅是營運穩健的基礎，更是投資人與客戶信任的重要保障。未來我們將持續推動內部稽核、資安演練與教育訓練，提升全體同仁的資安意識，資安深植在企業文化中，確保企業持續具備強韌性與競爭力。為達到國際認證體系的標準要求，115年將進行新一輪的三年循環認證，持續推動ISMS在面對威脅時方能自我調適，讓本公司的資安治理更趨成熟且融入日常營運中。",
  "investor_550":"",
  "investor_551":"證書是一個指標也是承諾，日後仍將定期執行資訊安全的內部演練與教育訓練，推動全體同仁重視資科保護，提升全員對於資安的意識和警覺，使資訊安全防護臻於完善，保障我們企業之權益。本公司為精進ISMS系統符合最新規範;將推動ISO 27001 2022年版的轉版計劃預計2025年九月底前取得有效證書。",
  "investor_552":"113年組織資訊安全教育訓練或培訓共531小時，包含針對一般員工之社交工程教育訓練、法治教育訓練439小時，以及資安執行小組成員訓練92小時。",
  "investor_553":"第一屆第十八次",
  "investor_554":"第一屆第十九次",
  "investor_555":"第一屆第二十次",
  "investor_556":"第二屆第一次",
  "investor_557":"第二屆第二次",
  "investor_558":"第二屆第三次",
  "investor_559":"112.01.17",
  "investor_560":"112.03.23",
  "investor_561":"112.05.04",
  "investor_562":"112.08.10",
  "investor_563":"112.11.09",
  "investor_564":"112.12.20",
  "investor_565":"1.擬資金貸與子公司八方雲集餐飲股份有限公司新台幣1億元額度案",
  "investor_566":"2.擬資金貸與子公司Bafang Yunji Foods LLC美金150萬元及資金貸與子公司Bafang Yunji Restaurant Group LLC美金300萬元案",
  "investor_567":"3.擬為子公司丹堤咖啡食品股份有限公司背書保證案",
  "investor_568":"4.擬為子公司Bafang Yunji Foods LLC及Bafang Yunji Restaurant Group LLC提供背書保證案",
  "investor_569":"5.擬修訂本公司「公司治理實務守則」案",
  "investor_570":"1.111年度決算表冊案",
  "investor_571":"2.本公司111年度盈餘分配案",
  "investor_572":"3.112年度會計師公費暨獨立性評估審核案",
  "investor_573":"4.擬通過本公司之「內部控制制度聲明書」案",
  "investor_574":"5.擬為子公司丹堤咖啡食品股份有限公司背書保證案",
  "investor_575":"1.擬通過本公司112年第1季合併財務報表案",
  "investor_576":"2.擬訂定本公司「關係人相互間財務業務相關作業規範」，同時廢止「關係人交易管理辦法」案",
  "investor_577":"3.擬訂定本公司「簽證會計師提供非確信服務預先核准之審核辦法」案",
  "investor_578":"4.擬預先核准112年簽證會計師提供非確信服務項目案",
  "investor_579":"1.擬通過本公司112年第2季合併財務報表案",
  "investor_580":"2.112年上半年度盈餘分配案",
  "investor_581":"3.擬取得不動產案",
  "investor_582":"4.擬增資子公司丹堤咖啡食品股份有限公司案",
  "investor_583":"5.本公司112年度對「財團法人新北市私立八方雲集社會福利慈善事業基金會」捐贈新台幣三百萬元案",
  "investor_584":"1.擬通過本公司112年第3季合併財務報表案",
  "investor_585":"2.擬增資100%轉投資子公司Bafang Yunji International (USA) Limited及間接投資設立美國子公司案",
  "investor_586":"3.擬解散清算香港子公司八方雲集餐飲連鎖集團有限公司案",
  "investor_587":"4.擬訂定本公司113年度稽核計劃案",
  "investor_588":"1.本公司擬於嘉義縣大林鎮興建蔬菜冷藏庫案",
  "investor_589":"2.本公司擬於淡水天元段廠房建置新產線案",
  "investor_590":"內部稽核目的",
  "investor_591":"在促進公司健全經營並建立良好之內部控制制度，協助董事會及經理人評估及覆核內部控制制度之缺失，及衡量營運之效果及效率，並適時提供改進建議，以確保內部控制制度得以持續有效實施，及作為檢討修正內部控制制度之依據。",
  "investor_592":"內部稽核組織",
  "investor_593":"本公司稽核室為一獨立單位，隸屬於董事會。組織圖如下：",
  "investor_594":"內部稽核之運作",
  "investor_595":"本公司稽核工作主要依據董事會通過的年度稽核計畫執行，該稽核計畫係參照風險評估結果擬訂，另視營運需要不定期安排專案稽核。",
  "investor_596":"內部稽核作業完成後，本室會將查核結果與受查單位充分溝通，並據實揭露於稽核報告呈核，而對於受查單位之改善對策亦加以追蹤至改善為止。",
  "investor_597":"稽核報告(含追蹤報告)除於完成之次月底前交付各獨立董事查閱外，內部稽核主管於每次召開之審計委員會及董事會中進行報告，並在每季進行一次與獨立董事單獨報告會議。",
  "investor_598":"內部稽核覆核各單位所執行的自行檢查，包括檢查該作業是否執行並覆核文件以確保執行的品質，並綜合自行檢查結果，並向審計委員會及董事會報告，以作為評估整體內部控制制度有效性及出具內部控制制度聲明書之依據。",
  "investor_599":"內部稽核人員任免、考核與薪資報酬",
  "investor_600":"本公司內部稽核人員任用資格符合金融監督管理委員會規定之適任條件，內部稽核主管之任免，經審計委員會同意，並提董事會決議通過。另內部稽核人員之考核係依據「績效考核辦法」每年執行二次，並由內部稽核主管呈報董事長核定。",
  "investor_609":"本公司內部稽核人員取得國際內部稽核師證照1張",
  "investor_601":"第五屆董事會",
  "investor_602":"(任期112年6月15日-115年6月14日)",
  "investor_603":"董事會成員",
  "investor_604":"董事會績效評估",
  "investor_605":"為落實公司治理並提升本公司董事會功能，建立績效目標以加強董事會運作效能，本公司已於110年4月8日由董事會通過本公司董事會績效評估辦法，每年執行內部董事會績效評估，應至少每三年由外部專業獨立機構或外部專家學者團執行評估一次。評估對象包含整體董事會(含功能性委員會)及個別董事成員之績效表現。而董事會內部及外部績效評估結果，應於次一年度第一季結束前完成。",
  "investor_606":"●董事會、董事成員及功能性委員會之內部績效評估報告",
  "investor_607":"113年度",
  "investor_608":"114年度",
  "investor_P01":"member231228TW.jpg",
  "ESG_00":"企業永續",
  "ESG_01":"永續發展實務",
  "ESG_02":"利害關係人",
  "ESG_03":"永續發展",
  "ESG_04":"人權政策",
  "ESG_05":"永續報告書下載",
  "ESG_06":"●顧客意見管理",
  "ESG_06_1":"●客戶權益政策",
  "ESG_06_2":"創立至今以來，本公司不僅堅持以一致的經營理念提供美味且安全的產品，同時也致力於為顧客帶來優質的服務體驗。我們所有客服團隊都接受專業且完整的內部培訓，具備專業知識、真誠態度及耐心特質，始終以「真心、尊重、關懷」的精神來服務每位顧客。我們深信，企業和品牌能夠永續發展的基石，正是來自於消費者和顧客對八方雲集的支持與認可。",
  "ESG_06_3":"●打造消費者全方位滿意度-客訴處理程序",
  "ESG_06_4":"本公司透過持續完整且不斷優化客戶服務流程，在既有標準作業程序中，增加溫度來打造消費者與顧客滿意的全方位客戶服務流程，顧客的回饋是我們最大的進步動力，藉由不斷的檢視改善與發現問題，才能更貼近顧客需求的服務模式。",
  "ESG_06_5":"本公司已訂有「客訴處理作業辦法」，客服單位接獲消費者客訴時，依客訴內容將填寫「消費者客訴處理記錄單」建檔立案。如遇情節重大客訴，我們將即時通報並派員到店了解與後續處理，並取回客訴樣品轉由食安單位進行異常分析判斷，於確認異常原因後由權責單位進行改善防止再發措施，並安排秘密客探訪門市，以確保改善之有效性",
  "ESG_06_6":"●傾聽消費者的聲音-客訴處理管道",
  "ESG_06_7":"本公司透過多元管道傾聽消費者的聲音，如：官網意見信箱email、0800 專線等。並建立嚴謹的服務流程，每日客服部將多方進線的意見反映分類建檔，並記錄所有處理歷程，解決顧客反饋的問題，同時即時提供給業務單位及中央工廠各單位作為參考。",
  "ESG_06_8":"●定期反饋檢討客訴意見分析",
  "ESG_06_9":"1.公關客服單位定期統計客訴案件，以利相關單位檢討分析，擬定矯正與預防措施。",
  "ESG_06_10":"2.傾聽客戶的聲音，回覆客人提出的意見，一方面能讓客人感到被重視，也凸顯出客服在服務的用心，以及展現集團接受指教負責任的態度。",
  "ESG_06_11":"3.尤其進入網路世代，客服迅速處理以及補救，不僅有機會幫助企業將危機化為轉機，更有助於企業累積正面聲量。",
  "ESG_06_12":"●環境管理",
  "ESG_06_13":"●環境管理政策",
  "ESG_06_14":"本公司於114年10月制定《環境安全衛生與能源管理政策》，將環境保護列為政策之一。我們透過識別重大環境衝擊及能源使用來源，持續推動污染防治、節能減碳、廢棄物減量與資源循環再利用。因應氣候變遷，我們透過推動碳盤查及減碳措施，以邁向淨零轉型。",
  "ESG_06_15":"●環境管理制度及114年執行情形",
  "ESG_06_16":"本公司依循環境部之環保法規訂有《環境與安全衛生管理手冊》及相關ISO管理辦法，並持續落實環境管理方案。114年已執行環境管理方案，包含噪音防治之週界噪音監測，以及廢棄物減量方面之建置電子簽核表單減少廢紙等相關方案。",
  "ESG_06_17":"●ISO14001證書取得情形",
  "ESG_06_18":"本公司淡水廠已於114年7月舉辦ISO14001教育訓練並啟動專案導入，共計24名同仁已取得ISO14001內部稽核人員研習證書，並已於114年11月通過認證取得ISO 14001證書，效期為114年11月13日至 117年11月12日。",
  "ESG_06_19":"●水資源統計",
  "ESG_06_20":"在餐飲製造業的生產流程中，從原料準備到實際製程都仰賴穩定的水資源供應。由於近年氣候變遷影響日益顯著，水資源的管理與使用效率逐漸成為八方雲集內外部利害關係人所關切的重要議題。本公司112年及113年度用水量(取水量)皆已取得外部驗證。",
  "ESG_06_21":"●能源管理",
  "ESG_06_22":"●能源管理政策",
  "ESG_06_23":"本公司於114年10月制定《環境安全衛生與能源管理政策》，將能源管理列為政策之一。我們透過識別重大環境衝擊及能源使用來源，持續推動污染防治、節能減碳、廢棄物減量與資源循環再利用。此外，本公司落實節能設計理念，優先採購節能產品與服務，逐步提升能源管理績效。",
  "ESG_06_24":"●能源管理計畫及114年執行情形",
  "ESG_06_25":"本公司計畫推動碳盤查的同時鑑別重大能源使用來源，並透過設定節能減碳目標、推動綠色能源使用，達到提高能源使用效率及減碳之效果，114年已完成台灣據點碳盤查，預計115年完成集團權據點碳盤查並依法規制定減碳目標。。",
  "ESG_06_26":"114年八方雲集之西螺廠及二崙倉太陽能設備裝置容量分別為99.22KWp與177.94KWp，114年1至10月太陽能發電共取得91張再生能源憑證(T-REC)。預計115年於工廠另新增裝置容量349.77KWp，提高本公司總綠色能源裝置容量及使用量。",
  "ESG_06_27":"●ISO50001證書取得情形",
  "ESG_06_28":"本公司淡水廠已於已於114年11月通過認證取得ISO 14001環境管理證書，預計於115年取得ISO50001證書，持續優化能源管理制度。",
 

  "ESG_001":"八方雲集永續發展推動組依據AA1000利害關係人議合標準(AA1000 Stakeholder Engagement Standards)，透過「依賴程度」、「影響力」、「責任」及「多元觀點」等五大面向進行判斷，並透過高階主管內部問卷鑑別出主要利害關係人。",
  "ESG_001_1":"利害關係人鑑別結果",
  "ESG_001_2":"我們共識別出八類主要利害關係人，包括：員工、加盟主、供應商、消費者、主管機關、投資人/股東、媒體/社群及社區居民。其中，媒體與社群於113年新增，主要因當年媒體與網路社群報導量增長，影響品牌形象與營運績效。",
  "ESG_002":"與利害關係人溝通",
  "ESG_0021":"八方雲集重視各利害關係人所關注的議題，並將其納入公司管理方針與執行計畫的參考。本公司之發言人及代理發言人為利害關係人主要溝通管道，並於公司官網及公開資訊觀測站上均設有聯絡方式及信箱，以多元的溝通管道揭露資訊，確保能與利害關係人獲得有效且良好之溝通成果。利害關係人溝通情形已於114年3月13日向董事會報告。",
  "ESG_003":"本公司董事會自110年訂有「永續發展實務守則」，並依守則規範執行運作，成立永續發展推動組，定期向董事會報告永續發展政策、制度或相關管理方針及計畫之提出及執行。111年於永續發展推動小組轄下成立「溫室氣體盤查及查證小組」，並向董事會報告每季至少一次；112年6月成立「風險管理委員會」(現永續發展暨風險管理委員會)後，「溫室氣體盤查及查證小組」除維持每季向董事會彙報溫室氣體相關執行情形外，由風險管理委員會(現永續發展暨風險管理委員會)負責氣候變遷風險管理相關運作機制之監督。114年8月「風險管理委員會」變更名稱為「永續發展暨風險管理委員會，永續兼職單位則維持由公司治理室兼任。",
  "ESG_0030":"訂定「企業社會責任守則」",
  "ESG_0031":"掛牌上市",
  "ESG_0032":"成立永續發展推動組",
  "ESG_0033":"發布第1本永續報告書",
  "ESG_0034":"發布第1本英文永續報告書",
  "ESG_0035":"修訂「企業社會責任實務守則」並更名為「永續發展實務守則」",
  "ESG_0036":"擬訂「永續報告書編製及驗證之作業程序」",
  "ESG_0037":"發布第2本永續報告書",
  "ESG_0038":"發布第2本英文永續報告書",
  "ESG_0039":"112年社會公益執行情形",
  "ESG_077":"本公司致力維護員工基本人權，認同並支持「聯合國全球盟約」、「聯合國世界人權宣言」及「國際勞工組織工作基本原則與權利宣言」等國際公認之人權標準，以實際行動體現本公司尊重與保護人權之責任，遵守公司所在地勞動、性別工作平等相關法規規範，禁止強迫、杜絕任何侵犯及違反人權的行為。本公司的人權政策包含對多元的包容性及確保工作機會均等；遵循勞動法令規範，確保僱用政策無差別待遇且不強迫勞動。禁止年齡歧視，保障中高齡者勞動權益，建構友善就業環境；及不非法僱用童工。",
  "ESG_078":"落實職場多元性，不因員工個人性別(含性傾向)、種族、階級、年齡、婚姻、語言、思想、宗教、黨派、籍貫、出生地、容貌、五官及身心障礙等，而有差別待遇或任何形式之歧視。",
  "ESG_079":"另本公司已於章程明定保留提撥不低於1%之員工酬勞，制訂「員工酬勞實施辦法」，將經營績效成果反映於員工。",
  "ESG2021":"110年",
  "ESG2022":"111年",
  "store_1": "輸入店名或路名搜尋",
  "store_2_0": "縣市",
  "store_2": "選擇縣市",
  "store_3_0": "區域",
  "store_3": "選擇區域",
  "store_4": "提供麵點",
  "store_4_0": "線上訂餐",
  "store_5_0": "付款方式",
  "store_5": "支付方式 / 可複選支付方式",
  "store_6_0": "活動篩選",
  "store_6_1": "活動",
  "store_6": "活動篩選 / 可複選活動",
  "store_7": "立即搜尋",
  "store_7_0": "立即搜尋",
  "store_8": "地址",
  "store_9": "電話",
  "store_10": "營業時間",
  "store_11": "線上訂餐",
  "news_1": "最新消息",
  "news_2": "重要公告",
  "news_3": "新品上市",
  "news_4": "分類",
  "news_5": "發布日期",
  "news_6": "上一篇",
  "news_7": "下一篇",
  "news_8": "更多內容",
  "contact_1": "常見問題",
  "contact_2": "意見反應",
  "contact_3": "我要加盟",
  "contact_4": "人才招募",
  "contact_5": "主旨",
  "contact_6": "回覆方式",
  "contact_7": "填表人",
  "contact_8": "電話",
  "contact_9": "反應門市",
  "contact_10": "內容",
  "contact_11": "信箱",
  "contact_12": "內容",
  "contact_13": "上傳檔案",
  "contact_14": "驗證碼",
  "contact_15": "我已經閱讀及同意個資條款",
  "contact_16": "確認送出",
  "contact_17": "傾聽您的建議 免付費客服",
  "contact_18": "請問在哪裡可以看到八方雲集的店家資訊?",
  "contact_19": "請點選我們官網上的門市資訊欄位，即可查詢所有八方雲集台灣門市的地址及電話。",
  "contact_20": "請問店家的營業時間是?",
  "contact_21": "每家店的營業時間會依照當店的產品實際銷售狀況有所不同，建議可直接撥打電話向店家詢問營業時間。",
  "contact_22": "請問你們每家店的價格都一樣嗎?",
  "contact_23": "因地域性的不同，所以不同區的店家在價格上會有稍許的落差。",
  "contact_24": "請問有菜單嗎？",
  "contact_25": "因每家門店販售商品不一，建議可直接向欲購買門店索取紙本菜單。",
  "contact_26": "請問XX鍋貼/水餃的熱量多少？",
  "contact_27": "我們官網上的安心餐點選項，都有標註每份餐點的熱量。",
  "contact_28": "請問小菜跟豆漿有整包販售嗎？",
  "contact_29": "有的，但因物料為每天總公司配送至店家，建議可事先向店家訂購。",
  "contact_30": "請問要怎麼樣加盟八方雲集?",
  "contact_31": "您可在官網的「聯絡我們」裡填寫加盟詢問表單，我們將有專人盡快與您聯繫。",
  "contact_32": "請問你們的產品有添加麻油嗎？",
  "contact_33": "我們的餡料都有加麻油，除珍珠餡沒有。",
  "contact_34": "請問你們的產品有添加奶蛋過敏原嗎？",
  "contact_35": "目前工廠生產的所有品項皆無直接添加蛋、奶於產品中，原物料本身則不在此限。",
  "contact_36": "請問你們的新蔬食產品內餡有什麼？",
  "contact_37": "為全蔬食製作絞肉、高麗菜、小麥蛋白。",
  "contact_38": "請問門店有提供什麼支付方式？",
  "contact_39": "依各家門店合作狀況，可上官網門市資訊查詢。",
  "contact_40": "請問為什麼外送平台的價格跟店家不一樣？",
  "contact_41": "因外送店家與平台配合會有額外的成本，透過平台訂購會與現場價格不同，若有價格考量，建議您也可以直接到店家購買。",
  "contact_42": "請問多少錢可以外送?",
  "contact_43": "因地區性不同，所以店家外送門檻也會有所不同，如需外送服務可直接向欲訂購的門市查詢當店外送之最低金額，店內人員會依據外送地點之遠近及當日店內人力配置，告知是否可提供外送服務。",
  "contact_44": "請問有販售冷凍鍋貼嗎？",
  "contact_45": "有的，可向門店事先詢問訂購。",
  "contact_46": "請問為何你們的豆漿保存期限這麼短？",
  "contact_47": "因產品未添加防腐劑，開封後須盡快飲用完畢，以低溫保存且切勿碰到生水，避免變質。",
  "contact_48": "請問你們豆漿使用的黃豆是非基改的嗎?",
  "contact_49": "我們的豆漿採用非基改的黃豆，且無添加防腐劑及人工香料，敬請安心食用。",
  "contact_50": "請問為什麼買你們的生鮮水餃回家煮都會煮破？",
  "contact_51": "因烹煮方式及時間皆會影響，請務必於水滾後再下水餃烹煮。",
  "contact_52": "請問吃鍋邊素在八方雲集可以點哪些餐點?",
  "contact_53": "吃鍋邊素可以點麻醬乾麵、新蔬食鍋貼或水餃，吃純素的客人則可購買新蔬食生鮮鍋貼或水餃回家自行烹煮。",
  "contact_54": "請問有些水餃跟鍋貼皮是有顏色的，是加了色素嗎?",
  "contact_55": "我們的水餃皮跟鍋貼皮是完全不加色素及防腐劑的，綠皮是使用綠藻粉、玉米皮跟咖哩皮是加了薑黃粉，因此可安心食用。",
  "contact_56": "為何有些店有開發票，有些店沒有開發票?",
  "contact_57": "每一家加盟店都是獨立的商號，在申請商號時會由當地稅捐單位核定是否需要開立統一發票，但無論是否開立發票，店家都還是要繳稅。",
  "contact_58": "服務相關",
  "contact_59": "產品相關",
  "contact_60": "衛生相關",
  "contact_61": "業務相關",
  "contact_62": "其他",
  "contact_63": "感謝您瀏覽本網站，請詳細填寫以下表單並清楚告訴我們您的訴求，我們收到留言將盡快與您連絡，再次感謝您。",
  "contact_65": "請輸入您的名稱",
  "contact_66": "請輸入您的電話",
  "contact_67": "請輸入您的信箱",
  "contact_68": "請輸入門市名稱",
  "contact_69": "請輸入您的內容",
  "contact_70": "未選擇任何檔案",
  "contact_72": "請輸入驗證碼",
  "contact_73": "請選擇主旨",
  "contact_74": "請選擇回覆方式",
  "contact_75": "我要加盟",
  "contact_76": "店點提供",
  "join_1": "誠摯邀請有意了解加盟合作的夥伴，填寫加盟意願表，我們將盡快與您聯繫。",
  "join_2": "姓名",
  "join_3": "請輸入姓名",
  "join_4": "性別",
  "join_5": "男性",
  "join_6": "女性",
  "join_7": "年齡",
  "join_8": "請輸入您的年齡",
  "join_9": "電話",
  "join_10": "請輸入您的電話",
  "join_11": "加盟區域",
  "join_12": "婚姻",
  "join_13": "已婚",
  "join_14": "未婚",
  "join_15": "信箱",
  "join_16": "請輸入電子信箱",
  "join_17": "地址",
  "join_18": "請輸入郵遞區號",
  "join_19": "請填寫詳細地址",
  "join_20": "工作經驗",
  "join_21": "請選擇縣市",
  "join_22": "請選擇區域",
  "join_23": "為配合門市拓展計劃，我們正在尋找符合條件的租賃標的，誠摯邀請提供合適店面或賣場空間的夥伴與我們聯繫",
  "join_24": "樓層",
  "join_25": "是否為房東本人",
  "join_26": "租金",
  "join_27": "管理費",
  "join_28": "室內坪數",
  "join_29": "面寬",
  "join_30": "是否可以營登",
  "join_31": "附近商圈/學區",
  "join_32": "房東",
  "join_33": "仲介",
  "join_34": "代理人",
  "join_35": "是",
  "join_36": "否",
  "feedbackTitle": "成功送出",
  "feedbackTip": "感謝您告訴我們您的訴求，我們將盡快與您連絡，再次感謝您。",
  "ok": "確認",
  "emailError": "信箱格式輸入錯誤",
  "phoneError": "電話格式輸入錯誤",

  "pleseSelect":"請選擇",
  "check":"请勾選同意條款"

}



// WEBPACK FOOTER //
// ./src/i18n/lang/tw.js